<template>
  <div v-loading="loading">
    <div class="signBox">
      <div class="imgBox"></div>
      <div>
        <div class="bannerBox">
          <div class="titleBox">
            <img src="../assets/images/LOGOs.png" alt="" style="height:43px">
            <p>生物医疗销售全流程管理系统注册页面</p>
          </div>
          <div class="whiteBox">
            <!--<div class="h-pieceTitle2" style="margin-top: 40px;margin-bottom: 20px;" v-if="this.flag[0]==='0'&&this.usercode == undefined">
              <h1>请选择角色信息</h1>
            </div>
            &lt;!&ndash; <div style="margin-top: 40px;" class="titles" v-if="this.flag[0]==='0'&&this.usercode == undefined">请选择角色信息</div> &ndash;&gt;
            <div class="buttonBox" v-if="this.flag[0]==='0'&&this.usercode == undefined">
              <div class="selebutton" @click="go(index)" :class="{'active':index==indx}"
                   v-for="(item,index) in list" :key="index">{{item}}
              </div>
            </div>-->
            <!--经销商-->
            <div v-if="indx==0">
              <!-- <div class="titles">客户类型</div> -->
              <div class="h-pieceTitle2" style="margin-top: 40px;margin-bottom: 20px;">

              </div>
              <!--<el-radio-group v-model="radio"
                              :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'"
                              @change="changeType">
                  <el-radio-button label="国内客户"></el-radio-button>
               </el-radio-group>-->
              <el-button style="" @click="lookFlow()" type="success">查询审核进度</el-button>
              <el-input style="margin-left: 50px; width: 30%;" v-model="companycodeForLookFlow" placeholder="请输入公司名称"></el-input>

              <div style="margin-top: 20px;">
                <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem">*
                  如果您是直单用户，请勾选下方按钮，如果不是请不要勾选！
                </div>
                <el-switch @change="chooseZhiDan" v-model="isZhiDan" active-text="是否是直单用户" inactive-text="">
                </el-switch>
                <el-switch style="margin-left: 50px;" v-if="this.isZhiDan == true" @change="chooseGoverment" v-model="isGoverment" active-text="是否是政府企业/军工企业" inactive-text="">
                </el-switch>
                <el-switch style="margin-left: 50px;" @change="chooseAddAbroad" v-model="isExpandAuthority" active-text="是否开通海外下单权限" inactive-text=""></el-switch>
                <el-switch style="margin-left: 50px;" @change="chooseFenxiao" v-model="isFenxiao" active-text="是否分销商1.0" inactive-text=""></el-switch>
                <el-input style="margin-left: 40px; width: 15%;" v-model="username" placeholder="请输入公司名称" v-if="this.isFenxiao"></el-input>
                <el-input style="margin-left: 40px; width: 15%;" v-model="email" placeholder="请输入邮箱" v-if="this.isFenxiao"></el-input>
                <el-button style="margin-left: 40px" @click="lookFenxiao()" v-if="this.isFenxiao" type="success">查询并转签约</el-button>
                <!-- <el-switch
                    style="margin-left: 50px;"
                    @change="chooseIsBlood"
                    v-model="isBlood"
                    active-text="是否血站专用渠道"
                    inactive-text=""></el-switch> -->
              </div>
              <!-- <div style="margin-top:20px;font-size:12px">

                          </div><div style="margin-top:20px;font-size:12px">
                  血战专用渠道：
                  <el-radio v-model="isBlood" label="true">是</el-radio>
                  <el-radio v-model="isBlood" label="false">否</el-radio>
              </div> -->

              <!--                            <div class="titles">账户信息</div>-->
              <!--                            <div class="redText " style="margin-left:150px">-->
              <!--                                * 密码必须包含大写字母、小写字母、数字其中的两种-->
              <!--                            </div>-->
              <!--                            <div class="signsign">-->
              <!--                                <div class="h-formLine" style="margin-top:0.38rem">-->
              <!--                                    <el-form :model="formLabelAlign1.bscUserInfo" label-position="right"-->
              <!--                                             ref="formLabelAlign1a"-->
              <!--                                             :inline="true" :rules="rules"-->
              <!--                                             class="demo-ruleForm h-formbLine h-formbLine1">-->
              <!--                                        <el-form-item label="用户名" class="h-elformWrap-2" prop="username">-->
              <!--                                            <el-input v-model="formLabelAlign1.bscUserInfo.username"-->
              <!--                                                      placeholder="请填写"></el-input>-->
              <!--                                        </el-form-item>-->
              <!--                                        <el-form-item label="密码" class="h-elformWrap-2" prop="password">-->
              <!--                                            <el-input v-model="formLabelAlign1.bscUserInfo.password" placeholder="请填写"-->
              <!--                                                      type="password"></el-input>-->
              <!--                                        </el-form-item>-->
              <!--                                        <el-form :model="check" label-position="right" ref="formLabelAlign1b"-->
              <!--                                                 style="text-align:right;margin-top:-0.65rem;margin-right:0.58rem;"-->
              <!--                                                 :inline="true" :rules="rules"-->
              <!--                                                 class="demo-ruleForm h-formbLine h-formbLine1">-->
              <!--                                            <el-form-item label="确认密码" class="h-elformWrap-2" prop="checkpassword">-->
              <!--                                                <el-input v-model="check.checkpassword" placeholder="请填写"-->
              <!--                                                          type="password"></el-input>-->
              <!--                                            </el-form-item>-->
              <!--                                        </el-form>-->
              <!--                                    </el-form>-->
              <!--                                </div>-->
              <!--                            </div>-->
              <!-- <div class="titles" style="margin-top:30px">客户资质信息</div> -->
              <div class="h-pieceTitle2" style="margin: 30px 0 10px 0;">
                <h1>客户资质信息</h1>
              </div>
              <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem">*
                如您的注册申请被驳回，输入公司名称及邮箱可带出基础信息！
              </div>
              <div class="signsign">
                <div class="h-formLine" style="margin-top:0.38rem">
                  <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right" ref="formLabelAlign1c" :disabled="this.fenxiaozh" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                    <el-form-item label="公司名称" class="h-elformWrap-2" prop="customerName1">
                      <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" :title="formLabelAlign1.bscUserInfoAgentBasic.customerName1" v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1" placeholder="请填写完整的公司全称" oninput="value=value.trim()" @change="getBackUserInfo"></el-input>
                    </el-form-item>
                    <el-form-item label="客户" class="h-elformWrap-2" prop="scale">
                      <el-select :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.scale" placeholder="请选择">
                        <el-option label="小规模经营者" value="0"></el-option>
                        <el-option label="一般纳税人" value="1"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="公司地址" class="h-elformWrap-2" prop="companyAddress">
                      <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" :title="formLabelAlign1.bscUserInfoAgentBasic.companyAddress" v-model="formLabelAlign1.bscUserInfoAgentBasic.companyAddress" placeholder="请填写详细的公司地址"></el-input>
                    </el-form-item>
                    <!--                                        <el-form-item label="邮政编码" class="h-elformWrap-2" prop="postalCode">-->
                    <!--                                            <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'"-->
                    <!--                                                      v-model="formLabelAlign1.bscUserInfoAgentBasic.postalCode"-->
                    <!--                                                      maxlength="6" show-word-limit-->
                    <!--                                                      placeholder="请填写"></el-input>-->
                    <!--                                        </el-form-item>-->
                    <el-form-item label="公司性质" class="h-elformWrap-2" prop="companytype">
                      <el-select :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.companytype" placeholder="请选择">
                        <el-option label="体外诊断类" value="体外诊断类"></el-option>
                        <el-option label="实验室仪器类" value="实验室仪器类"></el-option>
                        <el-option label="实验室EPC类" value="实验室EPC类"></el-option>
                        <el-option label="医疗影像设备类" value="医疗影像设备类"></el-option>
                        <el-option label="试剂耗材" value="试剂耗材"></el-option>
                        <el-option label="医疗科研软件服务类" value="医疗科研软件服务类"></el-option>
                        <el-option label="社区卫生服务类" value="社区卫生服务类"></el-option>
                        <el-option label="其他" value="其他"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="公司邮箱" class="h-elformWrap-2" prop="email">
                      <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.email" :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4' ? '' : '请填写' " @change="getBackUserInfo"></el-input>
                    </el-form-item>
                    <el-form-item label="成立时间" class="h-elformWrap-2" prop="founded">
                      <el-date-picker :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.founded" type="date" placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="总经理姓名" class="h-elformWrap-2" prop="legal">
                      <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.legal" placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item label="年度营业规模(万元)" class="h-elformWrap-2" prop="achievement">
                      <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.achievement" placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item label="销售人员数量" class="h-elformWrap-2" prop="personnelNum">
                      <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" type="text" onkeyup="value=value.replace(/\D/g,'')" v-model="formLabelAlign1.bscUserInfoAgentBasic.personnelNum" placeholder="请填写数字"></el-input>
                    </el-form-item>
                    <el-form-item label="总经理联系方式" class="h-elformWrap-2" prop="legalPhone">
                      <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.legalPhone" placeholder="请填写手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="经营其他品牌" class="h-elformWrap-2" prop="brand">
                      <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.brand" placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人姓名" class="h-elformWrap-2" prop="name1">
                      <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.name1" placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人手机号" class="h-elformWrap-2" prop="contactMobilePhone">
                      <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model.trim="formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone" placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item v-if="this.isExpandAuthority == true" label="所在国家" class="h-elformWrap-2" prop="country">
                      <brselectlazy category="YLCountry_agent" :v="formLabelAlign1.bscUserInfoAgentBasic.country" v-model="formLabelAlign1.bscUserInfoAgentBasic.country" :clearable="true" style="width:100%" :disabled="this.isShowMassage === true ? true:false" />
                    </el-form-item>
                    <el-form-item label="所在地区" class="h-elformWrap-2" prop="region" v-if="this.isShowMassage === true ? true:false">
                      <brselectlazy category="YLRegion" :v="formLabelAlign1.bscUserInfoAgentBasic.region" v-model="formLabelAlign1.bscUserInfoAgentBasic.region" :clearable="true" style="width:100%" :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'" />
                    </el-form-item>
                    <el-form-item label="所在城市" class="h-elformWrap-2" prop="contactCity" v-if="this.isShowMassage === true ? true:false">
                      <el-select filterable :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.contactCity" placeholder="请选择">
                        <el-option v-for="(item,index) in addli" :key="index" :label="item" :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
              <div class="h-pieceTitle2" style="margin: 0 0 20px 0;" v-if="(!this.isFenxiao  && !this.isFenxiao2 ) || this.fenxiaozh">
                <h1>开票信息</h1>
                <span style="font-size: 14px;color: #a8a8a8;margin-left:19px;">凡是贵公司相关信息的变更请及时通知，以便及时调整，保证开票信息无误</span>
              </div>
              <!-- <div class="titles" style="margin-top:0">开票信息
                  <span style="font-size: 14px;color: #a8a8a8;margin-left:19px;">凡是贵公司相关信息的变更请及时通知，以便及时调整，保证开票信息无误</span>
              </div> -->
              <div class="signsign" v-if="(!this.isFenxiao  && !this.isFenxiao2 ) || this.fenxiaozh">
                <div class="h-formLine" style="margin-top:0.38rem">
                  <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right" ref="formLabelAlign1d" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">

                    <el-form-item label="客户名称" class="h-elformWrap-2" prop=customerName1>
                      <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" :title="formLabelAlign1.bscUserInfoAgentBasic.customerName1" v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1" placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item label="开票电话" class="h-elformWrap-2" prop=phoneNumber>
                      <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model.trim="formLabelAlign1.bscUserInfoAgentBasic.phoneNumber" placeholder="请填写"></el-input>
                    </el-form-item>
                    <!--                                        <el-form-item label="地址" class="h-elformWrap-2" prop="cityStreetRoom">-->
                    <!--                                        <el-select :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom"-->
                    <!--                                                   placeholder="请选择">-->
                    <!--                                            <el-option label="山东烟台" value="山东烟台"></el-option>-->
                    <!--                                            <el-option label="山东青岛" value="山东青岛"></el-option>-->
                    <!--                                        </el-select>-->
                    <!--                                            <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom"-->
                    <!--                                                      placeholder="请填写"></el-input>-->
                    <el-form-item label="开票地址" class="h-elformWrap-2" prop="cityStreetRoom">
                      <el-input clearable maxlength="86" :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" :title="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom" v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom">
                        <!--                                                <i-->
                        <!--                                                        class="el-icon-edit el-input__icon"-->
                        <!--                                                        slot="suffix"-->
                        <!--                                                        @click="handleIconClick2">-->
                        <!--                                                </i>-->
                      </el-input>
                    </el-form-item>
                    <!--                                        </el-form-item>-->
                    <!--                                        <el-form-item label="营业执照注册地址" class="h-elformWrap-2" prop="streetRoom">-->
                    <!--                                            <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.streetRoom"-->
                    <!--                                                      placeholder="请填写"></el-input>-->
                    <!--                                        </el-form-item>-->
                    <!--                                        <el-form-item label="公司电话" class="h-elformWrap-2" prop="phoneNumber">-->
                    <!--                                            <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'"-->
                    <!--                                                      v-model="formLabelAlign1.bscUserInfoAgentBasic.phoneNumber"-->
                    <!--                                                      placeholder="请填写"></el-input>-->
                    <!--                                        </el-form-item>-->
                    <!--                                        <el-form-item label="邮政编码" class="h-elformWrap-2" prop="postalCode">-->
                    <!--                                            <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'"-->
                    <!--                                                      v-model="formLabelAlign1.bscUserInfoAgentBasic.postalCode"-->
                    <!--                                                      maxlength="6" show-word-limit-->
                    <!--                                                      placeholder="请填写"></el-input>-->
                    <!--                                        </el-form-item>-->
                    <!--                                        <el-form-item label="联系人" class="h-elformWrap-2" prop="name1">-->
                    <!--                                            <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'"-->
                    <!--                                                      v-model="formLabelAlign1.bscUserInfoAgentBasic.name1"-->
                    <!--                                                      placeholder="请填写"></el-input>-->
                    <!--                                        </el-form-item>-->
                    <!--                                        <el-form-item label="联系电话"-->
                    <!--                                                      class="h-elformWrap-2"-->
                    <!--                                                      prop="phoneNumber1">-->
                    <!--                                            <el-input-->
                    <!--                                                    :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'"-->
                    <!--                                                    v-model="formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1"-->
                    <!--                                                    placeholder="请填写"></el-input>-->
                    <!--                                        </el-form-item>-->
                    <el-form-item label="纳税人登记号" class="h-elformWrap-2 active" prop="taxCode" v-if="this.agentType===1||this.agentType===2">
                      <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model.trim="formLabelAlign1.bscUserInfoAgentBasic.taxCode" placeholder="请填写" oninput="value=value.replace(/[^a-zA-Z0-9]/g, '')"></el-input>
                    </el-form-item>
                    <el-form :model="formLabelAlign1.bscUserInfoAgentBank" label-position="right" ref="formLabelAlign1e" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                      <!--                                            <el-form-item label="VAT税号" class="h-elformWrap-2" prop="vatCode">-->
                      <!--                                                <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBank.vatCode"-->
                      <!--                                                          placeholder="请填写"></el-input>-->
                      <!--                                            </el-form-item>-->
                      <!--                                    <el-form-item label="银行代码" class="h-elformWrap-2" prop="bankBranchCode">-->
                      <!--                                        <el-input-->
                      <!--                                            :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'"-->
                      <!--                                            type="text"-->
                      <!--                                            placeholder="请输入内容"-->
                      <!--                                            v-model="formLabelAlign1.bscUserInfoAgentBank.bankBranchCode"-->
                      <!--                                            maxlength="12"-->
                      <!--                                            minlength="12"-->
                      <!--                                            show-word-limit>-->
                      <!--                                        </el-input>-->
                      <!--                                    </el-form-item>-->
                      <!-- <div> -->

                      <el-form-item label="银行名称" class="h-elformWrap-2" prop="bankName">
                        <el-select v-model="formLabelAlign1.bscUserInfoAgentBank.bankName" :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" remote filterable clearable placeholder="请填写" :remote-method="getBackCodeSupply" @change="changeBackCodeSupply1($event)" @clear="clearBackCode1">
                          <el-option v-for="(item) in bankList" :key="item.bankBranchCode" :label="item.bankName" :value="item.bankBranchCode">
                          </el-option>
                        </el-select>
                        <!-- <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBank.bankName" :title="formLabelAlign1.bscUserInfoAgentBank.bankName" placeholder="请填写"></el-input> -->
                        <!--                                                    <brselectlazy-->
                        <!--                                                            category="BankCategory_agent"-->
                        <!--                                                            :v="formLabelAlign1.bscUserInfoAgentBank.bankBranchCode"-->
                        <!--                                                            v-model="formLabelAlign1.bscUserInfoAgentBank.bankBranchCode"-->
                        <!--                                                            :clearable="true"-->
                        <!--                                                            style="width:100%"-->
                        <!--                                                            :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'"/>-->
                      </el-form-item>
                      <el-form-item label="银行编号" class="h-elformWrap-2" prop="bankBranchCode">
                        <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model.trim="formLabelAlign1.bscUserInfoAgentBank.bankBranchCode" disabled placeholder="自带出"></el-input>
                      </el-form-item>
                      <!-- </div> -->
                      <el-form-item label="银行账户号" class="h-elformWrap-2" prop="accountHolderName">
                        <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model.trim="formLabelAlign1.bscUserInfoAgentBank.accountHolderName" placeholder="请填写"></el-input>
                      </el-form-item>
                      <el-form-item label="银行所属国家" class="h-elformWrap-2" prop="bankCountry">
                        <brselectlazy category="YLCountry_agent" :v="formLabelAlign1.bscUserInfoAgentBank.bankCountry" v-model="formLabelAlign1.bscUserInfoAgentBank.bankCountry" :clearable="true" style="width:100%" :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'" />
                      </el-form-item>
                    </el-form>
                  </el-form>
                  <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right" ref="formLabelAlign1f" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                    <el-form-item label="发票类型" class="h-elformWrap-2" prop="customerGroup1" style="padding-right:0px;margin-bottom: 0;">
                      <el-select :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'" placeholder="请选择" style="width: 2.2rem;" v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup1">
                        <el-option label="增值税发票" value="01"></el-option>
                        <el-option label="普通发票" value="02"></el-option>
                      </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="" class="h-elformWrap-2" style="padding-right:0px;margin-bottom: 0;">
                    </el-form-item>
                    <el-form-item label="" class="h-elformWrap-2" style="padding-right:0px;margin-bottom: 0;">
                    </el-form-item> -->
                    <!-- 补充 国际贸易条件 -->
                    <el-form-item label="国际贸易条件" class="h-elformWrap-2" prop="intCommercialTerms" v-if="this.isExpandAuthority == true">
                      <!-- <el-input v-model="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms" placeholder="请填写"></el-input> -->
                      <brselectlazy category="YlCommercialTerms" :showcode="true" :v="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms" v-model="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms" :clearable="true" />
                    </el-form-item>
                    <el-form-item label="国际贸易条件2" class="h-elformWrap-2" prop="intCommercialTerms2" v-if="this.isExpandAuthority == true">
                      <brselectlazy category="YlCommercialTerms" :showcode="true" :v="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2" v-model="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2" :clearable="true" />
                    </el-form-item>
                    <!-- <el-form-item label="货币种类" class="h-elformWrap-2"  prop="accountHolderName" v-if="this.isExpandAuthority == true">
                        <el-input v-model="formLabelAlign1.bscUserInfoAgentBank.accountHolderName" placeholder="请填写"></el-input>
                    </el-form-item> -->
                    <el-form-item label="货币种类" class="h-elformWrap-2" prop="currencyCode">
                      <brselectlazy category="YLCurrency" :v="formLabelAlign1.bscUserInfoAgentSell.currencyCode" v-model="formLabelAlign1.bscUserInfoAgentSell.currencyCode" :clearable="true" />
                    </el-form-item>
                    <el-form-item label="电票邮箱" class="h-elformWrap-2" prop="inEmail">
                      <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentSell.inEmail"></el-input>
                    </el-form-item>

                    <!-- <div style="text-align:right;margin-top:-45px;margin-right:42px">

                    </div> -->
                    <div style="text-align:left;margin-left:4px;">
                      <!--                                            <el-form-item label="销售组织" class="h-elformWrap-2" prop="salesGroup" style="margin-right:7px;">-->
                      <!--                                                <brselectlazy category="YLSalesOrganization_agent" :v="formLabelAlign1.bscUserInfoAgentSell.salesGroup" v-model="formLabelAlign1.bscUserInfoAgentSell.salesGroup" :clearable="true"-->
                      <!--                                                    style="width:2.27rem"  :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'"/>-->
                      <!--                                            </el-form-item>-->
                      <!--                                            <el-form-item label="货币种类" class="h-elformWrap-2" prop="currencyCode" >-->
                      <!--                                            <brselectlazy category="YLCurrency" :v="formLabelAlign1.bscUserInfoAgentSell.currencyCode" v-model="formLabelAlign1.bscUserInfoAgentSell.currencyCode" :clearable="true"-->
                      <!--                                                          style="width:2.29rem"   :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'"/>-->
                      <!--                                            </el-form-item>-->
                    </div>
                  </el-form>
                  <!--                                    <div style="text-align:right;width:100%;margin-top:-45px;margin-left:-36px;">-->
                  <!--                                        <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right" ref="formLabelAlign1g"-->
                  <!--                                                 :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">-->
                  <!--                                            <el-form-item label="邮箱" class="h-elformWrap-2" prop="email">-->
                  <!--                                                <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.email"-->
                  <!--                                                          :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4' ? '' : '请填写' "></el-input>-->
                  <!--                                            </el-form-item>-->
                  <!--                                        </el-form>-->
                  <!--                                    </div>-->
                </div>
              </div>

              <!-- <div class="titles" style="margin-top:40px">邮寄发票信息</div> -->
              <div class="h-pieceTitle2" style="margin:0 0 20px 0;" v-if="(!this.isFenxiao  && !this.isFenxiao2 ) || this.fenxiaozh">
                <h1>邮寄发票信息</h1>
              </div>
              <div class="signsign" v-if="(!this.isFenxiao  && !this.isFenxiao2 ) || this.fenxiaozh">
                <div class="h-formLine" style="margin-top:0.1rem">
                  <el-form :model="formLabelAlign1.bscUserInfoAgentCompany" label-position="right" ref="formLabelAlign1h" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                    <el-form-item label="邮寄接收人" class="h-elformWrap-2" prop="mailreceiver">
                      <el-input v-model="formLabelAlign1.bscUserInfoAgentCompany.mailreceiver" placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item label="电话" class="h-elformWrap-2" prop="receiverphone">
                      <el-input v-model.trim="formLabelAlign1.bscUserInfoAgentCompany.receiverphone" placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item label="选择邮寄地址" class="h-elformWrap-2" prop="mailaddress">
                      <el-input clearable :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" :title="formLabelAlign1.bscUserInfoAgentCompany.mailaddress" v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress">
                        <i class="el-icon-edit el-input__icon" slot="suffix" @click="handleIconClick">
                        </i>
                      </el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
              <div class="h-pieceIn2" v-if="(!this.isFenxiao  && !this.isFenxiao2 ) || this.fenxiaozh">
                <div class="h-pieceTitle2" style="margin:0 0 20px 0;">
                  <h1>上传附件</h1>
                </div>
                <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem" v-if="(!this.isFenxiao  && !this.isFenxiao2 ) || this.fenxiaozh">*
                  上传文件格式只能是 JPG或PNG或PDF 格式! 文件大小不能超过 5M!
                </div>
                <!-- <div class="titles" style="margin-top:0">上传附件</div> -->
                <div class="h-pieceCon2 weekplandetail30">
                  <div class="h-formLine">
                    <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right" ref="formLabelAlign1i" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                      <el-form-item label="请上传备案表" class="h-elformWrap-2" :prop="this.isZhiDan == true?  '': 'upload5' " v-if="have2">
                        <el-upload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload5" class="upload-demo" action="" :http-request="httpRequestAgent5" :on-remove="handleRemoveAgent5" :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :file-list="fileListAgent5" :auto-upload=true>
                          <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                      </el-form-item>
                      <el-form-item label="" class="HAVES-l h-elformWrap-2" style="padding-right:0">
                        <el-switch v-if="have2" style="margin-left: 0.25rem;" v-model="have6858" active-text="" inactive-text="是否包含6858">
                        </el-switch>
                        <el-switch v-if="have2" style="margin-left: 0.5rem;" v-model="have6840" active-text="" inactive-text="是否包含6840">
                        </el-switch>
                        <el-switch style="margin-left: 0.3rem;" v-model="have3" active-text="" inactive-text="是否有许可证">
                        </el-switch>
                      </el-form-item>
                      <!-- <el-form-item label="" class="h-elformWrap-2"> -->
                      <!-- <el-switch
                              style=""
                              v-model="have3"
                              active-text=""
                              inactive-text="是否有许可证">
                      </el-switch> -->
                      <!-- </el-form-item>
                      <el-form-item label="" class="h-elformWrap-2">

                      </el-form-item> -->
                      <!-- <div style="width: 100%;margin-bottom: 0.38rem;padding-left: 5.3rem;">
                          <el-switch
                                  style=""
                                  v-model="have3"
                                  active-text=""
                                  inactive-text="是否有许可证">
                          </el-switch>
                      </div> -->
                      <el-form-item label="请上传许可证" class="h-elformWrap-2" :prop="this.isGoverment == true? '': 'upload6' " v-if="have3">
                        <div style="display: flex;">
                          <el-upload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload6" class="upload-demo" action="" :http-request="httpRequestAgent6" :on-remove="handleRemoveAgent6" :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :file-list="fileListAgent6" :auto-upload=true>
                            <el-button size="small" type="primary">点击上传</el-button>

                          </el-upload>
                        </div>
                      </el-form-item>
                      <el-form-item label="许可证有效截止日期" class="h-elformWrap-2" prop="xkzEffectiveDate" v-if="have3">
                        <el-date-picker v-model="formLabelAlign1.bscUserInfoAgentSell.xkzEffectiveDate" type="date" placeholder="选择日期">
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item label="请上传企业营业执照" class="h-elformWrap-2" :prop="this.isZhiDan == true?  '': 'upload1'">
                        <el-upload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload1" ref="formLabelAlign1i" class="upload-demo" action="" :http-request="httpRequestAgent1" :on-remove="handleRemoveAgent1" :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :file-list="fileListAgent1" :auto-upload=true>
                          <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                      </el-form-item>
                      <el-form-item label="营业执照有效截止日期" class="h-elformWrap-2" prop="yyzzEffectiveDate" :prop="this.isZhiDan == true?  '': 'upload1'">
                        <el-date-picker v-model="formLabelAlign1.bscUserInfoAgentSell.yyzzEffectiveDate" type="date" placeholder="选择日期">
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item label="请上传银行开户证明" class="h-elformWrap-2" :prop="this.isZhiDan == true?  '': 'upload2'">
                        <el-upload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload2" class="upload-demo" action="" :http-request="httpRequestAgent2" :on-remove="handleRemoveAgent2" :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :file-list="fileListAgent2" :auto-upload=true>
                          <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                      </el-form-item>
                      <el-form-item label="请上传法人身份证" class="h-elformWrap-2" :prop="this.isZhiDan == true?  '': 'upload3'">
                        <el-upload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload3" class="upload-demo" action="" :http-request="httpRequestAgent3" :on-remove="handleRemoveAgent3" :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :file-list="fileListAgent3" :auto-upload=true>
                          <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                      </el-form-item>
                      <el-form-item label="一般纳税人提供相关资质证明" class="h-elformWrap-2" :prop="formLabelAlign1.bscUserInfoAgentBasic.scale=='1'? 'upload4': '' ">
                        <el-upload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload4" class="upload-demo" action="" :http-request="httpRequestAgent4" :on-remove="handleRemoveAgent4" :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :file-list="fileListAgent4" :auto-upload=true>
                          <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                      </el-form-item>
                      <!-- 委托汇款的附件-->
                      <el-form-item label="委托汇款附件" class="h-elformWrap-2" v-if="this.isExpandAuthority == true" :prop="formLabelAlign1.bscUserInfoAgentBasic.scale=='1'? 'upload7': '' ">
                        <el-upload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload7" class="upload-demo" action="" :http-request="httpRequestAgent7" :on-remove="handleRemoveAgent7" :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :file-list="fileListAgent7" :auto-upload=true>
                          <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                      </el-form-item>

                      <!-- 补充部分  是否包含III类6840(t体外诊断试剂) -->
                      <el-form-item class="HAVES-l h-elformWrap-2" style="padding-right:0">
                        <el-switch @change="chooseIVD" v-model="haveThree6840" inactive-text="" inactive-text="是否包含III类6840(体外诊断试剂)">
                        </el-switch>
                        <el-switch style="margin-left: 1.5rem;" v-model="have6854" active-text="" inactive-text="是否包含6854">
                        </el-switch>
                      </el-form-item>
                      <el-form-item label="" class="HAVES-l h-elformWrap-2" style="padding-right:0">

                        <el-switch style="margin-left: 1rem;" @change="choose2017" v-model="havepolicy2017" inactive-text="是否包含2017版分类目录">
                        </el-switch>

                        <el-switch style="margin-left: 0.4rem;" v-model="have1101" active-text="" v-if="policyFlag" inactive-text="是否包含11-01">
                        </el-switch>
                      </el-form-item>
                      <el-form-item label="" class="HAVES-l h-elformWrap-2" style="padding-right:0">
                        <el-switch style="margin-left: 0.4rem;" v-model="have2214" active-text="" v-if="policyFlag" inactive-text="是否包含22-14">
                        </el-switch>
                        <el-switch style="margin-left: 0.4rem;" v-model="have2215" active-text="" v-if="policyFlag" inactive-text="是否包含22-15">
                        </el-switch>
                        <el-switch style="margin-left: 0.4rem;" v-model="have2216" active-text="" v-if="policyFlag" inactive-text="是否包含22-16">
                        </el-switch>
                      </el-form-item>

                      <el-form-item label="三类经营许可证" class="h-elformWrap-2" v-if="this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 == true" :prop="formLabelAlign1.bscUserInfoAgentSell.haveThree6840 == true? 'upload8': '' ">
                        <el-upload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload8" class="upload-demo" action="" :http-request="httpRequestAgent8" :on-remove="handleRemoveAgent8" :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :file-list="fileListAgent8" :auto-upload=true>
                          <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                      </el-form-item>

                      <!-- <div class="uploadBoxCopy" style="margin-left:-10px;">
                                            <div class="upload" > -->

                      <!--                                            <div style="margin-left:1.65rem">-->
                      <!--                                                <el-switch-->
                      <!--                                                    v-model="have2"-->
                      <!--                                                    active-text=""-->
                      <!--                                                    inactive-text="是否有二类经营许可证">-->
                      <!--                                                </el-switch>-->
                      <!--                                            </div>-->
                    </el-form>
                    <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right" ref="formLabelAlign1i" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                      <el-form-item label="许可证号" class="h-elformWrap-2" :prop="formLabelAlign1.bscUserInfoAgentSell.haveThree6840 == true? 'licenseNumber': '' " v-if="this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 == 1">
                        <el-input v-model="formLabelAlign1.bscUserInfoAgentSell.licenseNumber" placeholder="请输入许可证号">
                        </el-input>
                      </el-form-item>

                    </el-form>
                  </div>
                </div>
              </div>
            </div>
            <!--供应商-->
            <div v-if="indx==1">
              <!--                            <div class="titles">账户信息</div>-->
              <!--                            <div class="redText " style="margin-left:150px">-->
              <!--                                * 密码必须包含大写字母、小写字母、数字其中的两种-->
              <!--                            </div>-->
              <div class="signsign">
                <div class="h-formLine" style="margin-top:0.28rem">
                  <template>
                    <el-radio v-model="supplier.bscUserInfoSupplierCopy.type" label="1">总部供应商
                    </el-radio>
                    <el-radio v-model="supplier.bscUserInfoSupplierCopy.type" label="2">上海直销供应商
                    </el-radio>
                  </template>

                  <!--                                    <el-form :model="supplier.bscUserInfo" label-position="right" ref="supplier1"-->
                  <!--                                             :rules="rules2" :inline="true"-->
                  <!--                                             class="demo-ruleForm h-formbLine h-formbLine1">-->
                  <!--                                        <el-form-item label="用户名" class="h-elformWrap-2" prop="username">-->
                  <!--                                            <el-input v-model="supplier.bscUserInfo.username"-->
                  <!--                                                      placeholder="请填写"></el-input>-->
                  <!--                                        </el-form-item>-->
                  <!--                                        <el-form-item label="密码" class="h-elformWrap-2" prop="password">-->
                  <!--                                            <el-input v-model="supplier.bscUserInfo.password" placeholder="请填写"-->
                  <!--                                                      type="password"></el-input>-->
                  <!--                                        </el-form-item>-->
                  <!--                                        <el-form :model="check" label-position="right" ref="supplier2"-->
                  <!--                                                 style="text-align:right;margin-top:-0.65rem;margin-right:33px"-->
                  <!--                                                 :inline="true" :rules="rules2"-->
                  <!--                                                 class="demo-ruleForm h-formbLine h-formbLine1">-->
                  <!--                                            <el-form-item label="确认密码" class="h-elformWrap-2" prop="checkpassword">-->
                  <!--                                                <el-input v-model="check.checkpassword" placeholder="请填写"-->
                  <!--                                                          type="password"></el-input>-->
                  <!--                                            </el-form-item>-->
                  <!--                                        </el-form>-->
                  <!--                                        <div style="text-align:left;">-->
                  <!--                                            <el-form-item label="纳税人登记号" class="h-elformWrap-2" prop="companycode">-->
                  <!--                                                <el-input placeholder="请输入"-->
                  <!--                                                          v-model="supplier.bscUserInfo.companycode"></el-input>-->
                  <!--                                            </el-form-item>-->
                  <!--                                        </div>-->
                  <!--                                    </el-form>-->
                  <el-form :model="supplier.bscUserInfoSupplierCopy" label-position="right" ref="supplier3" :rules="rules2" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                    <div class="h-rowCon">
                      <div class="h-pieceIn2">
                        <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                          <h1>基本信息</h1>
                        </div>
                        <div class="h-pieceCon2">
                          <div class="h-formLine weekplandetail30">
                            <el-form-item label="供应商名称" class="h-elformWrap-2" prop="userName">
                              <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.userName"></el-input>
                            </el-form-item>
                            <el-form-item label="街道/房号" class="h-elformWrap-2" prop="inStreetRoom">
                              <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.inStreetRoom"></el-input>
                            </el-form-item>
                            <el-form-item label="邮政编码" class="h-elformWrap-2" prop="inPostalCodeCity">
                              <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.inPostalCodeCity"></el-input>
                            </el-form-item>
                            <el-form-item label="供应商账户组" class="h-elformWrap-2" prop="InAccountGrpCode">
                              <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.InAccountGrpCode"></el-input>
                            </el-form-item>
                            <el-form-item label="对应公司代码" class="h-elformWrap-2" prop="subCompany">
                              <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.subCompany"></el-input>
                            </el-form-item>
                            <el-form-item label="电话" class="h-elformWrap-2" prop="inPhoneNumber">
                              <el-input placeholder="请输入" v-model.trim="supplier.bscUserInfoSupplierCopy.inPhoneNumber"></el-input>
                            </el-form-item>
                            <el-form-item label="国家" class="h-elformWrap-2" prop="inCountry">
                              <brselectlazy category="YLCountry_agent" :v="supplier.bscUserInfoSupplierCopy.inCountry" v-model="supplier.bscUserInfoSupplierCopy.inCountry" :clearable="true" />
                            </el-form-item>
                            <el-form-item label="地区" class="h-elformWrap-2" prop="inRegion">
                              <brselectlazy category="YLRegion" :v="supplier.bscUserInfoSupplierCopy.inRegion" v-model="supplier.bscUserInfoSupplierCopy.inRegion" :clearable="true" />
                            </el-form-item>
                          </div>
                        </div>
                      </div>
                      <el-form :model="supplier.bscUserInfo" label-position="right" ref="supplier1" :rules="rules2" :inline="true" style="margin-left: 10px;" class="demo-ruleForm h-formbLine h-formbLine1">
                        <div style="text-align:left;">
                          <el-form-item label="纳税人登记号" class="h-elformWrap-2" prop="companycode">
                            <el-input placeholder="请输入" v-model="supplier.bscUserInfo.companycode" oninput="value=value.replace(/[^a-zA-Z0-9]/g, '')"></el-input>
                          </el-form-item>
                          <el-form-item label="公司邮箱" class="h-elformWrap-2" prop="email">
                            <el-input placeholder="请输入" v-model="supplier.bscUserInfo.email"></el-input>
                          </el-form-item>
                        </div>
                      </el-form>
                      <div class="h-pieceIn2">
                        <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                          <h1>公司信息</h1>
                        </div>
                        <div class="h-pieceCon2">
                          <div class="h-formLine weekplandetail30">
                            <el-form-item label="销售组织" class="h-elformWrap-2" prop="companyCode">
                              <brselectlazy category="YlCompanyCode_agent" :v="supplier.bscUserInfoSupplierCopy.companyCode" v-model="supplier.bscUserInfoSupplierCopy.companyCode" :clearable="true" style="width:2.24rem" />
                            </el-form-item>
                          </div>
                        </div>
                      </div>
                      <div class="h-pieceIn2" style="margin-top: 0;">
                        <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                          <h1>银行信息</h1>
                        </div>
                        <div class="h-pieceCon2">
                          <div class="h-formLine weekplandetail30">
                            <el-form-item label="银行所属国家" class="h-elformWrap-2" prop="bankCountry">
                              <brselectlazy category="YLCountry_agent" :v="supplier.bscUserInfoSupplierCopy.bankCountry" v-model="supplier.bscUserInfoSupplierCopy.bankCountry" :clearable="true" />
                            </el-form-item>
                            <div>
                              <el-form-item label="银行名称" class="h-elformWrap-2" prop="bankName">
                                <el-select v-model="supplier.bscUserInfoSupplierCopy.bankName" remote filterable clearable placeholder="请填写" :remote-method="getBackCodeSupply" @change="changeBackCodeSupply($event)" @clear="clearBackCode">
                                  <el-option v-for="(item) in bankList" :key="item.bankBranchCode" :label="item.bankName" :value="item.bankBranchCode">
                                  </el-option>
                                </el-select>
                                <!-- <el-input v-model="supplier.bscUserInfoSupplierCopy.bankName" placeholder="请填写"></el-input> -->
                              </el-form-item>
                              <el-form-item label="银行编号" class="h-elformWrap-2" prop="bankBranchCode">
                                <el-input disabled v-model="supplier.bscUserInfoSupplierCopy.bankBranchCode" placeholder="请填写"></el-input>
                              </el-form-item>
                            </div>
                            <!--                                                        <el-form-item label="银行码" class="h-elformWrap-2"-->
                            <!--                                                                      prop="bankBranchCode">-->
                            <!--                                                            <brselectlazy category="BankCategory_agent"-->
                            <!--                                                                          :v="supplier.bscUserInfoSupplierCopy.bankBranchCode"-->
                            <!--                                                                          v-model="supplier.bscUserInfoSupplierCopy.bankBranchCode"-->
                            <!--                                                                          :clearable="true"-->
                            <!--                                                            />-->
                            <!--                                                        </el-form-item>-->
                            <el-form-item label="银行户主" class="h-elformWrap-2" prop="bankAccountNum">
                              <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.bankAccountNum"></el-input>
                            </el-form-item>
                            <el-form-item label="银行账户" class="h-elformWrap-2" prop="accountHolderName">
                              <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.accountHolderName"></el-input>
                            </el-form-item>
                            <el-form-item label="订单货币" class="h-elformWrap-2" prop="orderCurrency">
                              <brselectlazy category="YLCurrency" :v="supplier.bscUserInfoSupplierCopy.orderCurrency" v-model="supplier.bscUserInfoSupplierCopy.orderCurrency" :clearable="true" />
                            </el-form-item>
                            <el-form-item label="采购组织" class="h-elformWrap-2" prop="purchaseGrpCode">
                              <brselectlazy category="supplier_grp_code" :v="supplier.bscUserInfoSupplierCopy.purchaseGrpCode" v-model="supplier.bscUserInfoSupplierCopy.purchaseGrpCode" :clearable="true" />
                            </el-form-item>
                            <el-form-item label="PI合作伙伴" class="h-elformWrap-2" prop="partnerPi">
                              <el-input placeholder="请输入" v-model="supplier.bscUserInfoSupplierCopy.partnerPi"></el-input>
                            </el-form-item>
                          </div>
                        </div>
                      </div>
                      <div class="h-pieceIn2">
                        <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                          <h1>资质信息</h1>
                        </div>
                        <div class="h-pieceCon2 weekplandetail30">
                          <div class="h-formLine">
                            <el-form-item label="请上传营业执照" class="h-elformWrap-1" prop="upload1">
                              <el-upload style="margin-top: 0;" v-model="supplier.bscUserInfoSupplierCopy.upload1" class="upload-zizhi" action="" :http-request="httpRequest1" :on-remove="handleRemove1" :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :file-list="fileList1" :auto-upload=true>
                                <el-button size="small" type="primary">点击上传</el-button>
                              </el-upload>
                            </el-form-item>
                            <el-form-item label="请上传资质证书" class="h-elformWrap-2" prop="upload2" style="width:50%" v-if="have2">
                              <el-upload style="margin-top: 0;" v-model="supplier.bscUserInfoSupplierCopy.upload2" class="upload-demo" action="" :http-request="httpRequest2" :on-remove="handleRemove2" :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :file-list="fileList2" :auto-upload=true>
                                <el-button size="small" type="primary">点击上传</el-button>
                              </el-upload>
                            </el-form-item>
                            <!--                                                        <el-form-item label="请上传三级资质证书" class="h-elformWrap-2"-->
                            <!--                                                                      style="width:50%" prop="upload3" v-if="have2">-->
                            <!--                                                            <el-upload-->
                            <!--                                                                    v-model="supplier.bscUserInfoSupplierCopy.upload3"-->
                            <!--                                                                    class="upload-demo"-->
                            <!--                                                                    action=""-->
                            <!--                                                                    :http-request="httpRequest3"-->
                            <!--                                                                    :on-remove="handleRemove3"-->
                            <!--                                                                    :before-remove="beforeRemove"-->
                            <!--                                                                    multiple-->
                            <!--                                                                    :file-list="fileList3"-->
                            <!--                                                                    :auto-upload=true>-->
                            <!--                                                                <el-button size="small" type="primary">点击上传</el-button>-->
                            <!--                                                            </el-upload>-->
                            <!--                                                        </el-form-item>-->
                            <el-switch style="margin-left: 1rem;" v-model="have2" active-text="" inactive-text="是否有资质证书">
                            </el-switch>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-form>
                </div>
              </div>
            </div>
            <div class="checkBoxs">
              <el-checkbox v-model="checked" label="我已同意"></el-checkbox>
              <span class="textderictor" @click="goxieyi">《平台协议》</span>
            </div>
            <div class="sign" @click="insert('formLabelAlign1')" v-if="this.flag[0]==='0' && this.indx==0" style="position:relative;z-index:1;cursor:pointer;">注册
            </div>
            <div class="sign" @click="insertSupplier('supplier')" v-if="this.flag[0]==='0' && this.indx==1" style="position:relative;z-index:1;cursor:pointer;">注册
            </div>

            <el-button v-if="this.flag[0]==='1'" @click="goBack" style="position:relative;z-index:1">返回
            </el-button>
            <el-button type="primary" @click="insert('formLabelAlign1')" v-if="this.flag[0]==='1'" style="position:relative;z-index:1">提交
            </el-button>
            <div class="login" v-if="this.flag[0]==='0'">已经有账号？<span style="color: #2785e7;cursor:pointer;position:relative;z-index:1;" @click="toLogin">立刻登录</span></div>
          </div>
        </div>
        <div class="bottoms">
          Copyright Haier 2019. All rights reserved
        </div>
      </div>
    </div>
    <div v-if="agreeIs" class="agreeBox">
      <div class="agree">
        <div class="agreeTop">
          <div class="title">用户协议</div>
          <div class="desc">
            遵守中华人民共和国相关法律法规，包括但不限于《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《最高人民法院关于审理涉及计算机网络著作权纠纷案件适用法律若干问题的解释(法释[2004]1号)》、《全国人大常委会关于维护互联网安全的决定》、《互联网电子公告服务管理规定》、《互联网新闻信息服务管理规定》、《互联网著作权行政保护办法》和《信息网络传播权保护条例》等有关计算机互联网规定和知识产权的法律和法规、实施办法。</br>
            用户对其自行发表、上传或传送的内容负全部责任，所有用户不得在本站任何页面发布、转载、传送含有下列内容之一的信息，否则本站有权自行处理并不通知用户：</br>
            (1)违反宪法确定的基本原则的； </br>
            (2)危害国家安全，泄漏国家机密，颠覆国家政权，破坏国家统一的； </br>(3)损害国家荣誉和利益的； </br>(4)煽动民族仇恨、民族歧视，破坏民族团结的； </br>
            (5)破坏国家宗教政策，宣扬邪教和封建迷信的； </br>(6)散布谣言，扰乱社会秩序，破坏社会稳定的；</br>(7)散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的； </br>
            (8)侮辱或者诽谤他人，侵害他人合法权益的； </br>(9)煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的； </br>(10)以非法民间组织名义活动的；</br>
            (11)含有法律、行政法规禁止的其他内容的。
          </div>
        </div>
        <div class="agreeBottom" @click="agrees">
          <img src="../assets/images/chas.png" style="width: 0.6rem;">
        </div>
      </div>
    </div>
    <areaSelect :visible.sync="showflag" @choseObj="choseObj" v-if="showflag" v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress" :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" />
    <areaSelect :visible.sync="showflag2" @choseObj="choseObj2" v-if="showflag2" v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom" :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" />

    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid" />

  </div>
</template>
<script>
import ss from '../api/SystemService'
import uploadFile from "../api/process/account_complainUploadService";
import _ from "loadsh";
import uploaddown from "../utils/updownfile";

export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (/^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S+$/.test(value)) {
          if (this.check.checkpassword !== '') {
            this.$refs.formLabelAlign1a.validateField('checkpassword');
            callback();
          }

        } else {
          callback(new Error('密码必须包含大写字母、小写字母、数字其中的两种！'));
        }
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.formLabelAlign1.bscUserInfo.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validatePass3 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (/^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S+$/.test(value)) {
          if (this.check.checkpassword !== '') {
            this.$refs.supplier2.validateField('checkpassword');
          }
          callback();
        } else {
          callback(new Error('密码必须包含大写字母、小写字母、数字其中的两种！'));
        }

      }
    };
    var validatePass4 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.supplier.bscUserInfo.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validateCompany = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入公司名称'));
      } else if (value !== '' && this.isGoverment == false) {
        this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = value.trim();
        ss.SignService.checkCompany(value).then(response => {
          console.log(response, '验证公司信息')
          if (response.obj.status === '200') {
            if (this.usercode != undefined) {
              var isOldAgent = 'true';
            }
            ss.SignService.checkAgentCompany(value, isOldAgent).then(res => {
              if (res.f) {
                callback();
                this.companyData = response.obj.data;
                this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.companyData.address;
                // this.formLabelAlign1.bscUserInfoAgentBasic.http = this.companyData.websites[0].web_url;
                this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.companyData.econ_kind;
                this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.companyData.start_date;
                this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.companyData.regist_capi;
                this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.companyData.oper_name;
                this.formLabelAlign1.bscUserInfoAgentBasic.business = this.companyData.scope;
                this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.companyData.credit_no;
                this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.companyData.address;
                this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.companyData.contact.telephone;
              } else {
                callback(new Error('该公司已被注册，请直接登录！'))
              }
            })

          } else {
            callback(new Error('请输入正确的公司名称!'));
          }
        })

      } else if (value !== '' && this.isGoverment == true) {

      }
    };

    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error("请输入总经理联系方式！"));
      } else if (value !== '') {
        if (/^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/.test(value)) {
          callback();
        } else {
          callback(new Error("请填写手机号格式！"));
        }
      }
    };
    var validateemail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error("请输入必填项！"));
      } else if (value !== '') {
        // if (/^\w+([-+.,]\w+)*@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/.test(value)) {
        callback();
        // } else {
        //     callback(new Error("邮箱格式不正确！"));
        // }
      }
    };

    var validateCompanySupplier = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入公司名称'));
      } else if (value !== '') {
        ss.SignService.checkCompany(value).then(response => {
          console.log(response, '验证公司信息')
          if (response.f) {
            this.companyData = response.obj.data;
            callback();
            this.supplier.bscUserInfoSupplierCopy.inStreetRoom = this.companyData.address;
            this.supplier.bscUserInfo.companycode = this.companyData.credit_no;
            this.supplier.bscUserInfoSupplierCopy.inPhoneNumber = this.companyData.contact.telephone;
          } else {
            callback(new Error('请输入正确的公司名称!'));
          }
        })

      }
    };
    var validateTaxCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error("请输入必填项！"));
      } else if (value !== '') {
        if (/^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g.test(value)) {
          callback();
        } else {
          callback(new Error("格式不正确！"));
        }
      }
    };
    return {
      arealist2: [],
      data: {},
      usercode: '',
      MdmBankconfigInput: {},
      isZhiDan: false,
      isExpandAuthority: false,
      isFenxiao: false,
      isFenxiao2: false,
      haveThree6840: 0, //包含III类6840,默认否
      isBlood: false,//血站
      isGoverment: false,
      policyFlag: false,
      fenxiaozh: false,
      refid: null,
      agentType: 1,
      radio: '国内客户',
      have2: true,
      have3: false,
      havepolicy2017: false,
      have6858: false,
      have6840: false,
      have6854: false,
      have1101: false,
      have2214: false,
      have2215: false,
      have2216: false,
      reftype1: '供应商注册-营业执照信息',
      reftype2: '供应商注册-二级资质信息',
      reftype3: '供应商注册-三级资质信息',
      fileList1: [],
      fileList2: [],
      fileList3: [],
      addli: [],

      reftypeAgent1: '代理商注册-企业营业执照',
      reftypeAgent2: '代理商注册-银行开户证明',
      reftypeAgent3: '代理商注册-法人身份证',
      reftypeAgent4: '代理商注册-一般纳税人提供相关资质证明',
      reftypeAgent5: '代理商注册-二类经营许可证',
      reftypeAgent6: '代理商注册-三类经营许可证',
      reftypeAgent8: '三类6840经营许可证',
      fileListAgent1: [],
      fileListAgent2: [],
      fileListAgent3: [],
      fileListAgent4: [],
      fileListAgent5: [],
      fileListAgent6: [],
      fileListAgent7: [],
      fileListAgent8: [],
      //供应商注册信息，用于传入后台注册
      username: null,
      email: null,
      supplier: {
        bscUserInfo: {
          usercode: null,//员工编码/公司编码
          password: '',//密码
          usertype: null,//用户类别: 0-内部员工  1-经销商  2-供应商
          username: null,//公司名称/员工姓名username
          companycode: null,//公司名称/员工姓名username
          email: null,//邮箱
          phone: null,//联系人电话
          deptcode: null,//所属部门编码deptcode  公司用户为空
          userdept: null,//用户详细部门userdept  公司用户为空
          deptname: null,//部门名称deptname  公司用户为空
          firstline: null,//一线经理firstline  公司用户为空
          secondline: null,//二线经理secondline  公司用户为空
          status: null,//用户状态: 0--禁用/冻结  1--正常  2--用户被删除
          organization: null,//公司地址/住址机构
          cdate: null,//创建时间
          ldate: null,//更新时间
          logintimes: null,//登录次数: 记录登录尝试失败次数，登录失败5次就将status改为禁止，联系运维解开
          lastlogintime: null,//最后登录时间: 记录最后登录时间
          accountdate: null,//账户有效期
          area: null,//负责区域
          lucode: null,//更新人编码
          countrytype: null,//1- 国内  /  2- 国外   账户
          fileId: null,//1- 国内  /  2- 国外   账户
        },
        bscUserInfoSupplierCopy: {
          usercode: null,//公司编号
          userName: '',//公司名称
          inLanguage: null,// 语言 ,   , 扩充不用填 ,   ,
          inStreetRoom: null,// 街道/房号 ,   , 扩充不用填 ,   ,
          inPostalCodeCity: null,// 邮政编码 ,   , 扩充不用填 ,   ,
          inCountry: null,// 国家 , 条件: 选择框(Country) , 扩充不用填 ,   ,
          inRegion: null,// 地区 , 条件: 选择框(Region) , 扩充不用填 ,   ,
          inPhoneNumber: null,// 电话 ,   , 扩充不用填 ,   ,
          subCompany: null,// 对应公司代码 ,   , 扩充不用填（集团内法人公司供应商必填,填写该公司的4位公司代码） ,   ,
          companyCode: null,
          bankName: '',
          reconcileAccount: null,// 统驭科目 , 条件: 选择框(ReconcileAccount) 扩充 必填 通过供应商账户组和统御科目对照过程确定 ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
          sequenceNo: null,// 排序码 , 条件: 选择框(OrderCode) 扩充 必填 默认 001 ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
          paymentTerm: null,// 付款条件 , 条件: 选择框(PayTerm) 扩充 必填 默认 0000 ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
          paymentMethod: null,// 付款方式 , 条件: 选择框(PayMethod) 扩充 必填 默认 I ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
          accountHolderName: null,// 银行账户 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
          bankCountry: null,// 银行所属国家 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
          bankAccountNum: null,// 银行户主 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
          bankBranchCode: null,// 银行码 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
          purchaseGrpCode: null,// 采购组织 ,   ,  , 抓取表: T_VENDOR_PUR , 字段归属: 采购信息
          orderCurrency: null,// 订单货币 ,   ,  , 抓取表: T_VENDOR_PUR , 字段归属: 采购信息
          partnerPi: null,// PI合作伙伴 ,   ,  , 抓取表: T_VENDOR_PUR , 字段归属: 采购信息
          systemName: null,// 系统名称 , 条件: 扩充 必填 填写 ALM系统编号 , 可根据需要修改 ,   , 字段归属: 通用字段
          viewBank: null,// 是否更新银行 ,   , X代表更新 ,   , 字段归属: 通用字段
          viewBase: null,// 是否更新基本信息 ,   , X代表更新 ,   , 字段归属: 通用字段
          viewComp: null,// 是否更新公司信息 ,   , X代表更新 ,   , 字段归属: 通用字段
          viewPur: null,// 是否更新采购信息 ,   , X代表更新 ,   , 字段归属: 通用字段
          operateType: null,// 操作状态 , 条件: 扩充填写 EXTEND , 操作状态 ,   , 字段归属: 通用字段
          createdBy: null,// 创建人 , 条件: 非必填 建议填写流程的发起人 , 创建人 ,   ,
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用,0：删除标志
          type: '1',
          InAccountGrpCode: null,
          upload1: [],
          upload2: [],
          upload3: [],
        },
      },
      agreeIs: false,
      checked: true,
      loading: false,
      showhistory: null,
      //判断文件格式
      fileFlag: {
        type: Boolean,
        default: false
      },
      instid: '',
      ind: null,
      index: ['c', 'd', 'e', 'f', 'h', 'i'],
      indexSupplier: ['1', '3'],
      list: ["我是客户"],
      indx: 0,
      formLabelAlign1: {
        bscUserInfoAgentBasic: {
          usercode: null,
          customerNumber: null,
          accountGroup: "0280",// 科目组 , 配置项 , 调接口参数: YlCustomerAccountGroup , 字段输入限制:  0210 集团内客户 0260 海外客户 0280 国内客户 根据客户实际情况传入科目组代码  , 特殊限制:   付款条件销售平台更改
          customerName1: '',// 客户全称1 ,  ,   , 字段输入限制: 客户全名。国内客户要求与证件注册的名称相同 , 特殊限制:   更改账期接口（公司销售视图付款条件字段）
          customerTitle: null,// 客户标题 ,  ,   , 字段输入限制:  公司 先生 女士 先生和夫人 一般公司类客户数据，可以默认传入“公司”  ,
          searchTerm: null,// 搜索项 ,  ,   ,   ,
          postalCode: null,// 邮政编码 ,  ,   ,   ,
          country: null,// 国家代码 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 传入国家的代码，在list中选择 ,
          region: null,// 地区 , 配置项 , 调接口参数: YlRegion , 字段输入限制: 传入地区的代码，在国家代码下的list中选择 ,
          cityStreetRoom: null,// 城市 ,  ,   , 字段输入限制: 客户所在的城市中文名 ,
          streetRoom: null,// 街道 ,  ,   , 字段输入限制: 客户证件上的注册地址 ,
          phoneNumber: null,// 电话 ,  ,   , 字段输入限制: 客户证件上注册的电话，开发票使用 , 特殊限制: 最多16位
          language: null,// 语言代码 , 配置项 , 调接口参数: YlLanguageType , 字段输入限制: 默认传入“ZH” ,
          faxNumber: null,// 传真 ,  ,   ,   , 特殊限制: 最多16位
          contactMobilePhone: null,// 移动电话 ,  ,   ,   , 特殊限制: 最多16位
          companyCode: null,// 公司代码(记录0210账户组下客户公司对照关系) , 配置项 , 调接口参数: CompanyCode , 字段输入限制: 当建立集团内客户时，此字段不能为空，需传入集团4位公司代码 ,
          taxCode: null,// 纳税人登记号 ,  ,   , 字段输入限制: 客户证件注册的统一信用代码，开发票使用 ,
          name1: null,// 联系人名称 ,  ,   , 字段输入限制: 客户方联系人的名字 ,
          phoneNumber1: null,// 联系人电话1 ,  ,   , 字段输入限制: 客户方联系人的电话 , 特殊限制: 最多16位
          companyAddress: null,// 公司地址名 ,  ,   ,   ,
          contactCity: null,// 联系人城市 ,  ,   ,   ,
          isTrade: '',
          remark: '',//备注
          appellation: null,// 称谓 ,  ,   , 字段输入限制:  女士 先生  ,
          partnerFlagSp: null,// 是否有售达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          partnerFlagSh: null,// 是否有送达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          partnerFlagBp: null,// 是否有开票方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          partnerFlagPy: null,// 是否有付款方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          scale: null,//纳税人规模  0：小规模经营者   1：一般纳税人
          http: null,//公司网址
          companytype: null, //公司性质
          founded: null,//成立时间
          regmoney: null,//注册资本
          legal: null,//法人姓名
          introduce: null,//公司简介
          business: null,//主营
          achievement: null,//业绩
          personnelNum: null,//销售人员数量
          brand: null,//经营其他品牌
          legalPhone: null,//总经理联系方式
          resource: null,//资源
          email: null,//公司邮箱
          businessScale: null,
          staffing: null,
          agentType: '1',
          isFenxiao: null,
          signingFenxiao: null,
          isZhidan: 0,
          upload1: [],
          upload2: [],
          upload3: [],
          upload4: [],
          upload5: [],
          upload6: [],
          upload7: [],
          upload8: [],
        },
        bscUserInfoAgentBank: {
          usercode: null,//公司编码
          accountHolderName: null,// 银行帐户 ,  ,   , 字段输入限制: 开户许可证上的银行账号 ,
          bankCountry: null,// 银行所属国家 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 从国家列表中选择 ,
          bankBranchCode: null,// 银行码 , 配置项 , 调接口参数: 从MDM开放的银行接口中选择 , 字段输入限制: 从MDM开放的银行接口中选择 ,
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          vatCode: null,//VAT税号
          bankName: null//银行名称
        },
        bscUserInfoAgentSell: {
          usercode: null,//公司编码
          distributionChannel: null,// 分销渠道 , 配置项 , 调接口参数: YlSalesChannel ,   ,
          division: null,// 产品组 , 配置项 , 调接口参数: YLProductGroup , 字段输入限制: 默认00 ,
          salesGroup: null,// 销售组织 , 配置项 , 调接口参数: YLSalesOrganization ,   ,
          salesRegion: null,// 销售地区 , 配置项 , 调接口参数: YlSalesArea ,   ,
          customerGroup: null,// 客户组(经销商级别) , 配置项 , 调接口参数: YlCustomerGroup , 字段输入限制: 内销必填 ,
          currencyCode: null,// 货币代码 , 配置项 , 调接口参数: YlCurrency ,   ,
          customerPricingProccess: null,// 客户定价过程 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
          customerSummaryGroup: null,// 客户统计组 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
          shipCondition: null,// 装运条件 , 配置项 , 调接口参数: 默认传01 , 字段输入限制: 默认传01 ,
          shipPlant: null,// 交货工厂 , 配置项 , 调接口参数: YlPLPlantCode ,   ,
          accountDistributeGroup: null,// 客户组的帐户分配 , 配置项 , 调接口参数: YlAccountDistributeGroup ,   ,
          custTaxCategory: null,// 客户的税分类 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
          paymentTerms1: null,// 付款条件-未包含在最近模板 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认传0000 ,
          podRelation: null,// 与 POD 处理相关 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          orderPossibility: null,// 订单可能性 ,  ,   ,   ,
          intCommercialTerms: null,// 国际贸易条件 , 配置项 , 调接口参数: YlCommercialTerms , 字段输入限制: 外销必填 ,
          intCommercialTerms2: null,// 国际贸易条件(部分2) ,  ,   , 字段输入限制: 外销必填 ,
          fullDelivery: null,// 全部交货 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          partDelivery: null,// 每个项目允许的部分交货最大数 ,  ,   , 字段输入限制: 默认传9 ,
          orderComposeIdentif: null,// 订单组合标识 ,  ,   , 字段输入限制: 传X或空  默认传X ,
          customerGroup1: null,// 客户组 1(开票类型) , 配置项 , 调接口参数: YlCustomerGroup1 , 字段输入限制: 内销必填 ,
          customerGroup2: null,// 客户组 2(经销商类型) , 配置项 , 调接口参数: YlCustomerGroup2 , 字段输入限制: 内销必填 ,
          customerGroup3: null,// 客户组 3(渠道类型) , 配置项 , 调接口参数: YlCustomerGroup3 , 字段输入限制: 内销必填 ,
          rebate: null,// 回扣 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          closeRoundingOff: null,// 关闭舍入 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          permit: null,//资质标识 1二级 2三级
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          customerAssignGroup: '0280',
          intCommercialTerms: '',//贸易条件1
          intCommercialTerms2: '',//贸易条件2
          currencyCode: '',//货币种类
          licenseNumber: '',//许可证号
          xkzEffectiveDate: '',//许可证有效到期日
          yyzzEffectiveDate: '',//营业执照有效日期
          inEmail: '',//邮箱
        },
        bscUserInfoAgentCompany: {
          usercode: null,//公司编码
          companyCode: null,// 公司代码 , 配置项 , 调接口参数: YlCompanyCode ,   ,
          hq: null,// 总部 ,  ,   ,   ,
          reconcileAccount: null,// 统驭科目 , 配置项 , 调接口参数: YLReconcileAccount , 字段输入限制:  0230、0260、0280账户组默认1122002000 0210默认1122001000  ,
          sequenceNo: null,// 排序码 , 配置项 , 调接口参数: YlOrderCode , 字段输入限制: 默认001 ,
          paymentTerm: null,// 付款条款 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认0000 ,
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          mailreceiver: null,//邮寄接收人
          receiverphone: null,//接收人电话
          mailaddress: null,//邮寄地址
        },
        bscUserInfo: {
          usercode: null,//员工编码/公司编码
          password: '',//密码
          usertype: null,//用户类别: 0-内部员工  1-经销商  2-供应商
          username: '',//公司名称/员工姓名username
          email: null,//邮箱
          phone: null,//联系人电话
          deptcode: null,//所属部门编码deptcode  公司用户为空
          userdept: null,//用户详细部门userdept  公司用户为空
          deptname: null,//部门名称deptname  公司用户为空
          firstline: null,//一线经理firstline  公司用户为空
          secondline: null,//二线经理secondline  公司用户为空
          status: null,//用户状态: 0--禁用/冻结  1--正常  2--用户被删除
          organization: null,//公司地址/住址机构
          cdate: null,//创建时间
          ldate: null,//更新时间
          logintimes: null,//登录次数: 记录登录尝试失败次数，登录失败5次就将status改为禁止，联系运维解开
          lastlogintime: null,//最后登录时间: 记录最后登录时间
          accountdate: null,//账户有效期
          area: null,//负责区域
          lucode: null,//更新人编码
          countrytype: null,//1- 国内  /  2- 国外   账户
        },
        oldAgentCode: ''
      },
      //此对象用于将formLabelAlign1 还原
      formLabelAlignNull: {
        bscUserInfoAgentBasic: {
          usercode: null,
          customerNumber: null,
          accountGroup: "0280",// 科目组 , 配置项 , 调接口参数: YlCustomerAccountGroup , 字段输入限制:  0210 集团内客户 0260 海外客户 0280 国内客户 根据客户实际情况传入科目组代码  , 特殊限制:   付款条件销售平台更改
          customerName1: '',// 客户全称1 ,  ,   , 字段输入限制: 客户全名。国内客户要求与证件注册的名称相同 , 特殊限制:   更改账期接口（公司销售视图付款条件字段）
          customerTitle: null,// 客户标题 ,  ,   , 字段输入限制:  公司 先生 女士 先生和夫人 一般公司类客户数据，可以默认传入“公司”  ,
          searchTerm: null,// 搜索项 ,  ,   ,   ,
          postalCode: null,// 邮政编码 ,  ,   ,   ,
          country: null,// 国家代码 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 传入国家的代码，在list中选择 ,
          region: null,// 地区 , 配置项 , 调接口参数: YlRegion , 字段输入限制: 传入地区的代码，在国家代码下的list中选择 ,
          cityStreetRoom: null,// 城市 ,  ,   , 字段输入限制: 客户所在的城市中文名 ,
          streetRoom: null,// 街道 ,  ,   , 字段输入限制: 客户证件上的注册地址 ,
          phoneNumber: null,// 电话 ,  ,   , 字段输入限制: 客户证件上注册的电话，开发票使用 , 特殊限制: 最多16位
          language: null,// 语言代码 , 配置项 , 调接口参数: YlLanguageType , 字段输入限制: 默认传入“ZH” ,
          faxNumber: null,// 传真 ,  ,   ,   , 特殊限制: 最多16位
          contactMobilePhone: null,// 移动电话 ,  ,   ,   , 特殊限制: 最多16位
          companyCode: null,// 公司代码(记录0210账户组下客户公司对照关系) , 配置项 , 调接口参数: CompanyCode , 字段输入限制: 当建立集团内客户时，此字段不能为空，需传入集团4位公司代码 ,
          taxCode: null,// 纳税人登记号 ,  ,   , 字段输入限制: 客户证件注册的统一信用代码，开发票使用 ,
          name1: null,// 联系人名称 ,  ,   , 字段输入限制: 客户方联系人的名字 ,
          phoneNumber1: null,// 联系人电话1 ,  ,   , 字段输入限制: 客户方联系人的电话 , 特殊限制: 最多16位
          companyAddress: null,// 公司地址名 ,  ,   ,   ,
          contactCity: null,// 联系人城市 ,  ,   ,   ,
          isTrade: '',
          remark: '',//备注
          appellation: null,// 称谓 ,  ,   , 字段输入限制:  女士 先生  ,
          partnerFlagSp: null,// 是否有售达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          partnerFlagSh: null,// 是否有送达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          partnerFlagBp: null,// 是否有开票方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          partnerFlagPy: null,// 是否有付款方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          scale: null,//纳税人规模  0：小规模经营者   1：一般纳税人
          http: null,//公司网址
          companytype: null, //公司性质
          founded: null,//成立时间
          regmoney: null,//注册资本
          legal: null,//法人姓名
          introduce: null,//公司简介
          business: null,//主营
          achievement: null,//业绩
          resource: null,//资源
          email: null,//公司邮箱
          businessScale: null,
          staffing: null,
          agentType: '1',
          upload1: [],
          upload2: [],
          upload3: [],
          upload4: [],
          upload5: [],
          upload6: [],
          upload7: [],
          upload8: [],
        },
        bscUserInfoAgentBank: {
          usercode: null,//公司编码
          accountHolderName: null,// 银行帐户 ,  ,   , 字段输入限制: 开户许可证上的银行账号 ,
          bankCountry: null,// 银行所属国家 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 从国家列表中选择 ,
          bankBranchCode: null,// 银行码 , 配置项 , 调接口参数: 从MDM开放的银行接口中选择 , 字段输入限制: 从MDM开放的银行接口中选择 ,
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          vatCode: null,//VAT税号
          bankName: null//银行名称
        },
        bscUserInfoAgentSell: {
          usercode: null,//公司编码
          distributionChannel: null,// 分销渠道 , 配置项 , 调接口参数: YlSalesChannel ,   ,
          division: null,// 产品组 , 配置项 , 调接口参数: YLProductGroup , 字段输入限制: 默认00 ,
          salesGroup: null,// 销售组织 , 配置项 , 调接口参数: YLSalesOrganization ,   ,
          salesRegion: null,// 销售地区 , 配置项 , 调接口参数: YlSalesArea ,   ,
          customerGroup: null,// 客户组(经销商级别) , 配置项 , 调接口参数: YlCustomerGroup , 字段输入限制: 内销必填 ,
          currencyCode: null,// 货币代码 , 配置项 , 调接口参数: YlCurrency ,   ,
          customerPricingProccess: null,// 客户定价过程 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
          customerSummaryGroup: null,// 客户统计组 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
          shipCondition: null,// 装运条件 , 配置项 , 调接口参数: 默认传01 , 字段输入限制: 默认传01 ,
          shipPlant: null,// 交货工厂 , 配置项 , 调接口参数: YlPLPlantCode ,   ,
          accountDistributeGroup: null,// 客户组的帐户分配 , 配置项 , 调接口参数: YlAccountDistributeGroup ,   ,
          custTaxCategory: null,// 客户的税分类 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
          paymentTerms1: null,// 付款条件-未包含在最近模板 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认传0000 ,
          podRelation: null,// 与 POD 处理相关 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          orderPossibility: null,// 订单可能性 ,  ,   ,   ,
          intCommercialTerms: null,// 国际贸易条件 , 配置项 , 调接口参数: YlCommercialTerms , 字段输入限制: 外销必填 ,
          intCommercialTerms2: null,// 国际贸易条件(部分2) ,  ,   , 字段输入限制: 外销必填 ,
          fullDelivery: null,// 全部交货 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          partDelivery: null,// 每个项目允许的部分交货最大数 ,  ,   , 字段输入限制: 默认传9 ,
          orderComposeIdentif: null,// 订单组合标识 ,  ,   , 字段输入限制: 传X或空  默认传X ,
          customerGroup1: null,// 客户组 1(开票类型) , 配置项 , 调接口参数: YlCustomerGroup1 , 字段输入限制: 内销必填 ,
          customerGroup2: null,// 客户组 2(经销商类型) , 配置项 , 调接口参数: YlCustomerGroup2 , 字段输入限制: 内销必填 ,
          customerGroup3: null,// 客户组 3(渠道类型) , 配置项 , 调接口参数: YlCustomerGroup3 , 字段输入限制: 内销必填 ,
          rebate: null,// 回扣 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          closeRoundingOff: null,// 关闭舍入 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          permit: null,//资质标识 1二级 2三级
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          customerAssignGroup: '0280',
          intCommercialTerms: '',//贸易条件1
          intCommercialTerms2: '',//贸易条件2
          currencyCode: '',//货币种类
          licenseNumber: '',//许可证号
        },
        bscUserInfoAgentCompany: {
          usercode: null,//公司编码
          companyCode: null,// 公司代码 , 配置项 , 调接口参数: YlCompanyCode ,   ,
          hq: null,// 总部 ,  ,   ,   ,
          reconcileAccount: null,// 统驭科目 , 配置项 , 调接口参数: YLReconcileAccount , 字段输入限制:  0230、0260、0280账户组默认1122002000 0210默认1122001000  ,
          sequenceNo: null,// 排序码 , 配置项 , 调接口参数: YlOrderCode , 字段输入限制: 默认001 ,
          paymentTerm: null,// 付款条款 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认0000 ,
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          mailreceiver: null,//邮寄接收人
          receiverphone: null,//接收人电话
          mailaddress: null,//邮寄地址
        },
        bscUserInfo: {
          usercode: null,//员工编码/公司编码
          password: '',//密码
          usertype: null,//用户类别: 0-内部员工  1-经销商  2-供应商
          username: '',//公司名称/员工姓名username
          email: null,//邮箱
          phone: null,//联系人电话
          deptcode: null,//所属部门编码deptcode  公司用户为空
          userdept: null,//用户详细部门userdept  公司用户为空
          deptname: null,//部门名称deptname  公司用户为空
          firstline: null,//一线经理firstline  公司用户为空
          secondline: null,//二线经理secondline  公司用户为空
          status: null,//用户状态: 0--禁用/冻结  1--正常  2--用户被删除
          organization: null,//公司地址/住址机构
          cdate: null,//创建时间
          ldate: null,//更新时间
          logintimes: null,//登录次数: 记录登录尝试失败次数，登录失败5次就将status改为禁止，联系运维解开
          lastlogintime: null,//最后登录时间: 记录最后登录时间
          accountdate: null,//账户有效期
          area: null,//负责区域
          lucode: null,//更新人编码
          countrytype: null,//1- 国内  /  2- 国外   账户
        },
        oldAgentCode: ''
      },

      formLabelAlign2: {
        bscUserInfoSupplierSystem: {
          usercode: null,//公司编号
          inLanguage: null,// 语言 ,   , 扩充不用填 ,   ,
          inStreetRoom: null,// 街道/房号 ,   , 扩充不用填 ,   ,
          inPostalCodeCity: null,// 邮政编码 ,   , 扩充不用填 ,   ,
          inCountry: null,// 国家 , 条件: 选择框(Country) , 扩充不用填 ,   ,
          inRegion: null,// 地区 , 条件: 选择框(Region) , 扩充不用填 ,   ,
          inPhoneNumber: null,// 电话 ,   , 扩充不用填 ,   ,
          subCompany: null,// 对应公司代码 ,   , 扩充不用填（集团内法人公司供应商必填,填写该公司的4位公司代码） ,   ,
          companyCode: null,// 公司代码 , 条件: 选择框(CompanyCode) 扩充 必填 公司代码 ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
          reconcileAccount: null,// 统驭科目 , 条件: 选择框(ReconcileAccount) 扩充 必填 通过供应商账户组和统御科目对照过程确定 ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
          sequenceNo: null,// 排序码 , 条件: 选择框(OrderCode) 扩充 必填 默认 001 ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
          paymentTerm: null,// 付款条件 , 条件: 选择框(PayTerm) 扩充 必填 默认 0000 ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
          paymentMethod: null,// 付款方式 , 条件: 选择框(PayMethod) 扩充 必填 默认 I ,  , 抓取表: T_VENDOR_COMPANY , 字段归属: 公司信息
          accountHolderName: null,// 银行账户 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
          bankCountry: null,// 银行所属国家 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
          bankAccountNum: null,// 银行户主 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
          bankBranchCode: null,// 银行码 ,   ,  , 抓取表: T_VENDOR_BANK , 字段归属: 银行信息
          purchaseGrpCode: null,// 采购组织 ,   ,  , 抓取表: T_VENDOR_PUR , 字段归属: 采购信息
          orderCurrency: null,// 订单货币 ,   ,  , 抓取表: T_VENDOR_PUR , 字段归属: 采购信息
          partnerPi: null,// PI合作伙伴 ,   ,  , 抓取表: T_VENDOR_PUR , 字段归属: 采购信息
          systemName: null,// 系统名称 , 条件: 扩充 必填 填写 ALM系统编号 , 可根据需要修改 ,   , 字段归属: 通用字段
          viewBank: null,// 是否更新银行 ,   , X代表更新 ,   , 字段归属: 通用字段
          viewBase: null,// 是否更新基本信息 ,   , X代表更新 ,   , 字段归属: 通用字段
          viewComp: null,// 是否更新公司信息 ,   , X代表更新 ,   , 字段归属: 通用字段
          viewPur: null,// 是否更新采购信息 ,   , X代表更新 ,   , 字段归属: 通用字段
          operateType: null,// 操作状态 , 条件: 扩充填写 EXTEND , 操作状态 ,   , 字段归属: 通用字段
          createdBy: null,// 创建人 , 条件: 非必填 建议填写流程的发起人 , 创建人 ,   ,
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null//可用标志。1：可用,0：删除标志
        },
        bscUserInfo: {
          usercode: null,//员工编码/公司编码
          password: '',//密码
          usertype: null,//用户类别: 0-内部员工  1-经销商  2-供应商
          username: '',//公司名称/员工姓名username
          email: null,//邮箱
          phone: null,//联系人电话
          deptcode: null,//所属部门编码deptcode  公司用户为空
          userdept: null,//用户详细部门userdept  公司用户为空
          deptname: null,//部门名称deptname  公司用户为空
          firstline: null,//一线经理firstline  公司用户为空
          secondline: null,//二线经理secondline  公司用户为空
          status: null,//用户状态: 0--禁用/冻结  1--正常  2--用户被删除
          organization: null,//公司地址/住址机构
          cdate: null,//创建时间
          ldate: null,//更新时间
          logintimes: null,//登录次数: 记录登录尝试失败次数，登录失败5次就将status改为禁止，联系运维解开
          lastlogintime: null,//最后登录时间: 记录最后登录时间
          accountdate: null,//账户有效期
          area: null,//负责区域
          lucode: null,//更新人编码
          countrytype: null,//1- 国内  /  2- 国外   账户
        },
        outExcel: 0
      },
      check: {
        checkpassword: ''
      },
      rules: {
        /*username: [
            {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        password:
            [
                {required: true, validator: validatePass, trigger: 'blur'},
            ],
        checkpassword:
            [
                {required: true, validator: validatePass2, trigger: 'blur'},
            ],*/
        //公司名称
        customerName1:
          [
            { required: true, message: '请填写公司名称', trigger: 'blur' },
          ],
        //客户
        // scale:
        //     [
        //         {required: true, message: '请选择客户', trigger: 'change'},
        //     ],
        //公司地址
        companyAddress:
          [
            { required: true, message: '请填写公司地址', trigger: 'blur' },
          ],
        // email:
        //   [
        //     { required: true, message: '请填写公司邮箱', trigger: 'blur' },
        //   ],
        contactCity:
          [
            { required: true, message: '请选择城市信息', trigger: 'blur' },
          ],
        //所在地区
        region:
          [
            { required: true, message: '请填写所在地区', trigger: 'blur' },
          ],
        //货币种类
        currencyCode:
          [
            { required: true, message: '请填写货币种类', trigger: 'blur' },
          ],
        //总经理联系方式
        legalPhone:
          [
            { required: true, validator: validatePhone, trigger: 'blur' },
          ],

        //经营其他品牌
        brand:
          [
            { required: true, message: '请填写经营其他品牌', trigger: 'blur' },
          ],

        //请填写销售人员数量
        personnelNum:
          [
            { required: true, message: '请填写销售人员数量', trigger: 'blur' },
          ],

        //传真
        // faxNumber: [
        //     {required: true, message: '请填写传真', trigger: 'blur'},
        // ],
        //邮箱
        // email:
        //     [
        //         {required: true, validator: validateemail, trigger: 'blur'},
        //     ],
        //公司性质
        companytype:
          [
            { required: true, message: '请选择公司性质', trigger: 'change' },
          ],
        //成立时间
        founded:
          [
            { required: true, message: '请选择成立时间', trigger: 'blur' },
          ],
        //注册资金
        // regmoney:
        //     [
        //         {required: true, message: '请填写注册资金', trigger: 'blur'},
        //     ],
        //法人代表
        legal:
          [
            { required: true, message: '请填写法人代表', trigger: 'blur' },
          ],
        //公司简介
        // introduce:
        //     [
        //         {required: true, message: '请填写公司简介', trigger: 'blur'},
        //     ],
        //主营业务
        // business:
        //     [
        //         {required: true, message: '请填写主营业务', trigger: 'blur'},
        //     ],
        //主要业绩
        achievement:
          [
            { required: true, message: '请填写主要业绩', trigger: 'blur' },
          ],
        //主要用户资源
        // resource:
        //     [
        //         {required: true, message: '请填写主要用户资源', trigger: 'blur'},
        //     ],
        //接口人姓名
        name1:
          [
            { required: true, message: '请填写接口人姓名', trigger: 'blur' },
          ],
        //接口人手机号
        contactMobilePhone: [
          { required: true, validator: validatePhone, trigger: 'blur' },
        ],

        //经营规模
        // businessScale:
        //     [
        //         {required: true, message: '请填写经营规模', trigger: 'blur'},
        //     ],
        //人员配置
        // staffing:
        //     [
        //         {required: true, message: '请填写人员配置', trigger: 'blur'},
        //     ],
        //纳税人登记号
        taxCode: [
          // {required: true, validator: validateTaxCode, trigger: 'blur'},
          { required: true, message: '请填写纳税人登记号', trigger: 'blur' },
        ],
        //开票电话
        phoneNumber:
          [
            { required: true, message: '请填写开票电话', trigger: 'blur' },
          ],
        //开票地址
        cityStreetRoom:
          [
            { required: true, message: '请填写开票地址', trigger: 'blur' },
          ],
        //银行编号
        bankBranchCode:
          [
            { required: true, message: '请填写银行编号', trigger: 'blur' },
          ],
        //银行名称
        bankName:
          [
            { required: true, message: '请填写银行名称', trigger: 'blur' },
          ],
        country:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        //银行账户
        accountHolderName:
          [
            { required: true, message: '请填写银行账户', trigger: 'blur' },
          ],
        //发票类型
        customerGroup1:
          [
            { required: true, message: '请选择发票类型', trigger: 'blur' },
          ],
        //银行所属国家
        bankCountry:
          [
            { required: true, message: '请填写银行所属国家', trigger: 'blur' },
          ],
        intCommercialTerms: [
          { required: true, message: '请填写国际贸易条件', trigger: 'blur' }
        ],
        intCommercialTerms2: [
          { required: true, message: '请填写国际贸易条件2', trigger: 'blur' }
        ],
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        /* bankBranchCode:
            [
                {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        companyCode:
            [
                {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        reconcileAccount:
            [
                {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        distributionChannel:
            [
                {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        salesGroup:
            [
                {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        salesRegion:
            [
                {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        currencyCode:
            [
                {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        accountDistributeGroup:
            [
                {required: true, message: '请填写必填项', trigger: 'blur'},
            ],*/
        //邮箱地址
        // mailreceiver:
        //     [
        //         {required: true, message: '请填写邮件接收人', trigger: 'blur'},
        //     ],
        // receiverphone:
        //     [
        //         {required: true, message: '请填写电话', trigger: 'blur'},
        //     ],
        // mailaddress:
        //     [
        //         {required: true, message: '请选择邮寄地址', trigger: 'blur'},
        //     ],
        upload4:
          [
            { required: true, message: '请上传资料', trigger: 'blur' },
          ],
        upload1:
          [
            { required: true, message: '请上传资料', trigger: 'blur' },
          ],
        upload2:
          [
            { required: true, message: '请上传资料', trigger: 'blur' },
          ],
        upload3:
          [
            { required: true, message: '请上传资料', trigger: 'blur' },
          ],
        upload5:
          [
            { required: true, message: '请上传资料', trigger: 'blur' },
          ],
        upload6:
          [
            { required: true, message: '请上传资料', trigger: 'blur' },
          ],
        upload8:
          [
            { required: true, message: '请上传资料', trigger: 'blur' },
          ],
        xkzEffectiveDate:
          [
            { required: true, message: '请选择日期', trigger: 'blur' },
          ],
        yyzzEffectiveDate:
          [
            { required: true, message: '请选择日期', trigger: 'blur' },
          ],
        licenseNumber: [
          { required: true, message: '请输入许可证号', trigger: 'blur' },
        ],
        isTrade: [
          { required: true, message: '请填写必填项', trigger: 'blur' }
        ]
      },
      rules2: {
        username: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        password:
          [
            { required: true, validator: validatePass3, trigger: 'blur' },
          ],
        checkpassword:
          [
            { required: true, validator: validatePass4, trigger: 'blur' },
          ],
        userName:
          [
            { required: true, validator: validateCompanySupplier, trigger: 'blur' },
          ],
        email:
          [
            { required: true, validator: validateemail, trigger: 'blur' },
          ],
        inPhoneNumber:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        inCountry:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        inRegion:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        companycode:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        InAccountGrpCode:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        subCompany:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        companyCode:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        bankBranchCode:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        reconcileAccount:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        paymentTerm:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        paymentMethod:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        bankCountry:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        accountHolderName:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        bankAccountNum:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        accountHolderName:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        orderCurrency:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        purchaseGrpCode:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        partnerPi:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        /*upload1:
            [
                {required: true, message: '请上传资料', trigger: 'blur'},
            ],*/
        upload2:
          [
            { required: true, message: '请上传资料', trigger: 'blur' },
          ],
        upload3:
          [
            { required: true, message: '请上传资料', trigger: 'blur' },
          ],
      },
      flag: '',
      idList: [],
      updateFile: {
        idList: [],
        refid: null,
      },
      showflag: false,
      showflag2: false,
      isShowMassage: true,
      companycodeForLookFlow: '',
      bankList: []
    }
  },
  created () {
    console.log(this.$route.query.usercode, 'queryaaaaa')
    this.findAddress();
    this.usercode = this.$route.query.usercode;
    if (this.$route.query.usercode != undefined) {
      this.queryAgent();
    }
    this.refid = this.$util.getUuid();
    this.getCountryAndCity();
    this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
    this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122001000';
    this.formLabelAlign1.bscUserInfoAgentCompany.sequenceNo = '001';
    this.formLabelAlign1.bscUserInfoAgentCompany.paymentTerm = '0000';
    this.formLabelAlign1.bscUserInfoAgentSell.division = '00';
    this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
    this.formLabelAlign1.bscUserInfoAgentSell.customerPricingProccess = '1';
    this.formLabelAlign1.bscUserInfoAgentSell.customerSummaryGroup = '1';
    this.formLabelAlign1.bscUserInfoAgentSell.shipCondition = '01';
    this.formLabelAlign1.bscUserInfoAgentSell.custTaxCategory = '1';
    this.formLabelAlign1.bscUserInfoAgentSell.paymentTerms1 = '0000';
    this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 = 0

    this.formLabelAlign1.OperateType = 'CREATE';
    this.formLabelAlign1.OPERATOR = this._user.username;
    this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = 'CN';
    this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSp = '1';
    this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagBp = '1';
    this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagPy = '1';
    this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSh = '1';
  },
  methods: {
    // 移除银行编号
    clearBackCode1 () {
      this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = ''
    },
    //选择银行
    changeBackCodeSupply1 (val) {
      this.formLabelAlign1.bscUserInfoAgentBank.bankName = this.bankList.find(item => item.bankBranchCode == val).bankName
      this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = val
    },

    // 移除银行编号
    clearBackCode () {
      this.supplier.bscUserInfoSupplierCopy.bankBranchCode = ''
    },
    //选择银行
    changeBackCodeSupply (val) {
      this.supplier.bscUserInfoSupplierCopy.bankName = this.bankList.find(item => item.bankBranchCode == val).bankName
      this.supplier.bscUserInfoSupplierCopy.bankBranchCode = val
    },
    //模糊搜索银行
    getBackCodeSupply (value) {
      ss.SignService.getBackName({
        bankName: value
      }).then(response => {
        console.log(response, '银行名称对象')
        this.bankList = response.obj.bankTable.value.bankItem
      })
    },
    findAddress () {
      ss.SignService.selectAddress().then(response => {
        this.addli = response;
      })
    },
    getCity () {
      ss.SignService.getCityCode(this.formLabelAlign1.bscUserInfoAgentBasic.region).then(res => {
        ss.Dictservice.areaTreelist({ code: res }).then(rd => {
          console.log(rd)
          this.arealist2 = rd.zlist;
        })
      })
    },
    queryAgent () {
      ss.SignService.queryAgent(this.usercode).then(res => {
        console.log(res, '经销商信息')
        this.data = res.obj;
        this.checkDetail();
      })
    },
    //经销商查看功能对应展示数据功能
    checkDetail () {
      this.formLabelAlign1.bscUserInfo.usercode = this.data.usercodeInfo
      this.formLabelAlign1.bscUserInfoAgentBasic.usercode = this.data.usercodeBas
      this.formLabelAlign1.bscUserInfoAgentBank.usercode = this.data.usercodeBank
      this.formLabelAlign1.bscUserInfoAgentCompany.usercode = this.data.usercodeCom
      this.formLabelAlign1.bscUserInfoAgentSell.usercode = this.data.usercodeSell

      this.formLabelAlign1.bscUserInfo.username = this.data.usernameInfo
      this.formLabelAlign1.bscUserInfo.password = this.data.passwordInfo
      this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas
      if (this.data.scaleBas !== undefined) {
        this.formLabelAlign1.bscUserInfoAgentBasic.scale = this.data.scaleBas.toString()
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.data.companyaddressBas
      this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.faxNumber = this.data.faxnumberBas
      this.formLabelAlign1.bscUserInfoAgentBasic.http = this.data.httpBas
      this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.data.companytypeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.data.foundedBas
      this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.data.regmoneyBas
      this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.data.legalBas
      this.formLabelAlign1.bscUserInfoAgentBasic.introduce = this.data.introduceBas
      this.formLabelAlign1.bscUserInfoAgentBasic.business = this.data.businessBas
      this.formLabelAlign1.bscUserInfoAgentBasic.achievement = this.data.achievementBas
      this.formLabelAlign1.bscUserInfoAgentBasic.resource = this.data.resourceBas
      this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone = this.data.contactmobilephoneBas
      this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = this.data.citystreetroomBas
      this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.data.streetroomBas
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.data.phonenumberBas
      this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
      this.formLabelAlign1.bscUserInfoAgentBank.vatCode = this.data.vatcodeBank
      this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = this.data.bankbranchcodeBank
      this.formLabelAlign1.bscUserInfoAgentBank.bankName = this.data.banknameBank
      this.formLabelAlign1.bscUserInfoAgentBank.accountHolderName = this.data.accountholdernameBank
      if (this.data.customergroup1Sell !== undefined) {
        this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell.toString()
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.email = this.data.emailBas
      this.formLabelAlign1.bscUserInfoAgentCompany.mailreceiver = this.data.mailreceiverCom
      this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone = this.data.receiverphoneCom
      this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = this.data.mailaddressCom
      this.formLabelAlign1.bscUserInfoAgentSell.auditMind1 = this.data.auditmind1Sell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup = this.data.customergroupSell
      this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = this.data.customerassigngroupSell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup2 = this.data.customergroup2Sell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.data.customergroup3Sell
      this.formLabelAlign1.bscUserInfoAgentSell.salesRegion = this.data.salesregionSell
      this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms = this.data.intcommercialtermsSell
      this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2 = this.data.intcommercialterms2Sell

      this.formLabelAlign1.bscUserInfoAgentBasic.contactCity = this.data.contactcityBas
      this.formLabelAlign1.bscUserInfoAgentBasic.appellation = this.data.appellationBas
      this.formLabelAlign1.bscUserInfoAgentBasic.country = this.data.countryBas
      this.formLabelAlign1.bscUserInfoAgentBasic.region = this.data.regionBas
      this.formLabelAlign1.bscUserInfoAgentBasic.companyCodeGeneral = this.data.companycodegeneralBas
      this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = this.data.companycodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.data.taxcodeBas
      this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = this.data.bankcountryBank
      this.formLabelAlign1.bscUserInfoAgentSell.distributionChannel = this.data.distributionchannelSell
      this.formLabelAlign1.bscUserInfoAgentSell.salesGroup = this.data.salesgroupSell
      this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = this.data.currencycodeSell
      this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = this.data.accountdistributegroupSell
      this.formLabelAlign1.bscUserInfoAgentSell.inEmail = this.data.inEmailSell
      if (this.data.have6840Sell == 1) {
        this.have6840 = true;
      }
      if (this.data.have6854Sell == 1) {
        this.have6854 = true;
      }
      if (this.data.have6858Sell == 1) {
        this.have6858 = true;
      }
      if (this.data.have1101Sell == 1) {
        this.have1101 = true;
      }
      if (this.data.have22014Sell == 1) {
        this.have22014 = true;
      }
      if (this.data.have22015Sell == 1) {
        this.have22015 = true;
      }
      if (this.data.have22016Sell == 1) {
        this.have22016 = true;
      }
    },
    getBackName () {
      this.MdmBankconfigInput.bankBranchCode = this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode;
      ss.SignService.getBackName(this.MdmBankconfigInput).then(response => {
        console.log(response, '银行名称对象')
        this.formLabelAlign1.bscUserInfoAgentBank.bankName = response.obj.bankTable.value.bankItem[0].bankName;
      })
    },
    getBackNameSupply () {
      this.MdmBankconfigInput.bankBranchCode = this.supplier.bscUserInfoSupplierCopy.bankBranchCode;
      ss.SignService.getBackName(this.MdmBankconfigInput).then(response => {
        console.log(response, '银行名称对象')
        this.supplier.bscUserInfoSupplierCopy.bankName = response.obj.bankTable.value.bankItem[0].bankName;
      })
    },
    chooseZhiDan () {
      if (this.isZhiDan) {
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 1;
        console.log("这是一")
      } else {
        this.isGoverment = false;
        this.formLabelAlign1.bscUserInfoAgentBasic.companytype = "";
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 0;
        console.log("这是二")
      }
    },
    chooseGoverment () {
      if (this.isGoverment) {
        this.formLabelAlign1.bscUserInfoAgentBasic.companytype = "政府/军工企业";
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.companytype = "";
      }
    },
    //是否开通海外直单权限
    chooseAddAbroad () {
      if (this.isExpandAuthority) {
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = 1;
        console.log("开通权限")
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = 0;
        console.log("暂不开通")
      }
    },
    //是否分销商1.0
    chooseFenxiao () {
      if (this.isFenxiao) {
        this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao = 1;
        console.log("开通权限", this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao)
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao = 0;
        console.log("暂不开通", this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao)
      }
      this.fenxiaozh = false;
    },
    //是否开通血战 国内和上海特有
    chooseIsBlood () {
      if (this.isBlood) {
        this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = 1;
        console.log("开通血站")
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = 0;
        console.log("暂不开通血站")
      }
    },
    //是否开通体外试剂
    chooseIVD () {
      if (this.haveThree6840) {
        this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 = 1;
        console.log("包含")
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 = 0;
        console.log("不包含III类6840")
      }
    },
    //是否包含2017版分类目录
    choose2017 () {
      if (this.havepolicy2017) {
        this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 1;
        this.policyFlag = true;
        console.log("包含2017版分类目录")
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 0;
        console.log("不包含2017版分类目录")
        this.policyFlag = false;
      }
    },
    choseObj (obj) {
      console.log(obj)
      this.showflag = false;
      if (obj.zhenobj && obj.zhenobj.name) {
        this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.zhenobj.name + ' ' + obj.addrdetail;
      } else {
        this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.addrdetail;
      }
    },
    choseObj2 (obj) {
      console.log(obj)
      this.showflag2 = false;
      if (obj.zhenobj && obj.zhenobj.name) {
        this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.zhenobj.name + ' ' + obj.addrdetail;
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.addrdetail;
      }
    },
    handleIconClick () {
      this.showflag = true;
    },
    handleIconClick2 () {
      this.showflag2 = true;
    },
    changeType (v) {
      if (v === '上海直销') {
        this.agentType = 2;
        this.isShowMassage = true;
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0210';
        this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0210';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '2';

      } else if (v === '国内客户') {
        this.agentType = 2;
        this.isShowMassage = true;
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '1';

      }
    },
    httpRequest1 (params) {
      // console.log(params,"1111111111")
      const loading = this.$msg.loading("上传中...");
      uploadFile.upload(params.file, { companycode: this.refid, reftype: this.reftype1 }).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.fileList1.unshift(rd.obj);
        this.idList.push(rd.obj.id);
        this.supplier.bscUserInfoSupplierCopy.upload1.unshift("1");
      }).catch(error => {
        loading.close();
        this.fileList1.splice(0, 1);
        return Promise.reject(error);
      });
      return false;
    },
    httpRequest2 (params) {
      // console.log(params,"1111111111")
      const loading = this.$msg.loading("上传中...");
      uploadFile.upload(params.file, { companycode: this.refid, reftype: this.reftype2 }).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.fileList2.unshift(rd.obj);
        this.idList.push(rd.obj.id);
        this.supplier.bscUserInfoSupplierCopy.upload2.unshift("1");
      }).catch(error => {
        loading.close();
        this.fileList2.splice(0, 1);
        return Promise.reject(error);
      });
      return false;
    },
    httpRequest3 (params) {
      // console.log(params,"1111111111")
      const loading = this.$msg.loading("上传中...");
      uploadFile.upload(params.file, { companycode: this.refid, reftype: this.reftype3 }).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.fileList3.unshift(rd.obj);
        this.idList.push(rd.obj.id);
        this.supplier.bscUserInfoSupplierCopy.upload3.unshift("1");
      }).catch(error => {
        loading.close();
        this.fileList3.splice(0, 1);
        return Promise.reject(error);
      });
      return false;
    },
    httpRequestAgent1 (params) {
      // console.log(params,"1111111111")
      const loading = this.$msg.loading("上传中...");
      uploadFile.upload(params.file, { companycode: this.refid, reftype: this.reftypeAgent1 }).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.fileListAgent1.unshift(rd.obj);
        this.idList.push(rd.obj.id);
        this.formLabelAlign1.bscUserInfoAgentBasic.upload1.unshift("1");
      }).catch(error => {
        loading.close();
        this.fileListAgent1.splice(0, 1);
        return Promise.reject(error);
      });
      return false;
    },
    httpRequestAgent2 (params) {
      // console.log(params,"1111111111")
      const loading = this.$msg.loading("上传中...");
      uploadFile.upload(params.file, { companycode: this.refid, reftype: this.reftypeAgent2 }).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.fileListAgent2.unshift(rd.obj);
        this.idList.push(rd.obj.id);
        this.formLabelAlign1.bscUserInfoAgentBasic.upload2.unshift("1");
      }).catch(error => {
        loading.close();
        this.fileListAgent2.splice(0, 1);
        return Promise.reject(error);
      });
      return false;
    },
    httpRequestAgent3 (params) {
      // console.log(params,"1111111111")
      const loading = this.$msg.loading("上传中...");
      uploadFile.upload(params.file, { companycode: this.refid, reftype: this.reftypeAgent3 }).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.fileListAgent3.unshift(rd.obj);
        this.idList.push(rd.obj.id);
        this.formLabelAlign1.bscUserInfoAgentBasic.upload3.unshift("1");
      }).catch(error => {
        loading.close();
        this.fileListAgent3.splice(0, 1);
        return Promise.reject(error);
      });
      return false;
    },
    httpRequestAgent4 (params) {
      // console.log(params,"1111111111")
      const loading = this.$msg.loading("上传中...");
      uploadFile.upload(params.file, { companycode: this.refid, reftype: this.reftypeAgent4 }).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.fileListAgent4.unshift(rd.obj);
        this.idList.push(rd.obj.id);
        this.formLabelAlign1.bscUserInfoAgentBasic.upload4.unshift("1");
      }).catch(error => {
        loading.close();
        this.fileListAgent4.splice(0, 1);
        return Promise.reject(error);
      });
      return false;
    },
    httpRequestAgent5 (params) {
      // console.log(params,"1111111111")
      const loading = this.$msg.loading("上传中...");
      uploadFile.upload(params.file, { companycode: this.refid, reftype: this.reftypeAgent5 }).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.fileListAgent5.unshift(rd.obj);
        this.idList.push(rd.obj.id);
        this.formLabelAlign1.bscUserInfoAgentBasic.upload5.unshift("1");
      }).catch(error => {
        loading.close();
        this.fileListAgent5.splice(0, 1);
        return Promise.reject(error);
      });
      return false;
    },
    httpRequestAgent6 (params) {
      // console.log(params,"1111111111")
      const loading = this.$msg.loading("上传中...");
      uploadFile.upload(params.file, { companycode: this.refid, reftype: this.reftypeAgent6 }).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.fileListAgent6.unshift(rd.obj);
        this.idList.push(rd.obj.id);
        this.formLabelAlign1.bscUserInfoAgentBasic.upload6.unshift("1");
      }).catch(error => {
        loading.close();
        this.fileListAgent6.splice(0, 1);
        return Promise.reject(error);
      });
      return false;
    },
    //委托汇款
    httpRequestAgent7 (params) {
      // console.log(params,"1111111111")
      const loading = this.$msg.loading("上传中...");
      uploadFile.upload(params.file, { companycode: this.refid, reftype: this.reftypeAgent7 }).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.fileListAgent7.unshift(rd.obj);
        this.idList.push(rd.obj.id);
        this.formLabelAlign1.bscUserInfoAgentBasic.upload7.unshift("1");
      }).catch(error => {
        loading.close();
        this.fileListAgent7.splice(0, 1);
        return Promise.reject(error);
      });
      return false;
    },
    //上传许可证
    httpRequestAgent8 (params) {
      // console.log(params,"1111111111")
      const loading = this.$msg.loading("上传中...");
      uploadFile.upload(params.file, { companycode: this.refid, reftype: this.reftypeAgent8 }).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.fileListAgent8.unshift(rd.obj);
        this.idList.push(rd.obj.id);
        this.formLabelAlign1.bscUserInfoAgentBasic.upload8.unshift("1");
      }).catch(error => {
        loading.close();
        this.fileListAgent8.splice(0, 1);
        return Promise.reject(error);
      });
      return false;
    },


    beforeRemove (file) {
      if (file && file.status === "success") {
        return this.$confirm(`确定移除 ${file.name}？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        });
      }
    },
    beforeUpload (file) {
      const isFile = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
      const isLt5M = file.size / 1024 / 1024 < 5;
      console.log(isFile, file.type)

      if (!isFile) {
        this.$message.error('上传文件的格式只能是 JPG或PNG或PDF 格式!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('上传文件的大小不能超过 5M!');
        return false;
      }
    },
    handleRemove1 (file) {
      console.log(file, "aaaaa");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      //删除fileList数据
      // console.log(this.fileList);
      for (var i = 0; i < this.fileList1.length; i++) {
        if (this.fileList1[i].id === id) {
          this.fileList1.splice(i, 1);
          // console.log(this.fileList)
        }
      }
    },
    handleRemove2 (file) {
      console.log(file, "aaaaa");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      //删除fileList数据
      // console.log(this.fileList);
      for (var i = 0; i < this.fileList2.length; i++) {
        if (this.fileList2[i].id === id) {
          this.fileList2.splice(i, 1);
          // console.log(this.fileList)
        }
      }
    },
    handleRemove3 (file) {
      console.log(file, "aaaaa");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      //删除fileList数据
      // console.log(this.fileList);
      for (var i = 0; i < this.fileList3.length; i++) {
        if (this.fileList3[i].id === id) {
          this.fileList3.splice(i, 1);
          // console.log(this.fileList)
        }
      }
    },
    handleRemoveAgent1 (file) {
      console.log(file, "aaaaa");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      //删除fileList数据
      // console.log(this.fileList);
      for (var i = 0; i < this.fileListAgent1.length; i++) {
        if (this.fileListAgent1[i].id === id) {
          this.fileListAgent1.splice(i, 1);
          // console.log(this.fileList)
        }
      }
    },
    handleRemoveAgent2 (file) {
      console.log(file, "aaaaa");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      //删除fileList数据
      // console.log(this.fileList);
      for (var i = 0; i < this.fileListAgent2.length; i++) {
        if (this.fileListAgent2[i].id === id) {
          this.fileListAgent2.splice(i, 1);
          // console.log(this.fileList)
        }
      }
    },
    handleRemoveAgent3 (file) {
      console.log(file, "aaaaa");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      //删除fileList数据
      // console.log(this.fileList);
      for (var i = 0; i < this.fileListAgent3.length; i++) {
        if (this.fileListAgent3[i].id === id) {
          this.fileListAgent3.splice(i, 1);
          // console.log(this.fileList)
        }
      }
    },
    handleRemoveAgent4 (file) {
      console.log(file, "aaaaa");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      //删除fileList数据
      // console.log(this.fileList);
      for (var i = 0; i < this.fileListAgent4.length; i++) {
        if (this.fileListAgent4[i].id === id) {
          this.fileListAgent4.splice(i, 1);
          // console.log(this.fileList)
        }
      }
    },
    handleRemoveAgent5 (file) {
      console.log(file, "aaaaa");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      //删除fileList数据
      // console.log(this.fileList);
      for (var i = 0; i < this.fileListAgent5.length; i++) {
        if (this.fileListAgent5[i].id === id) {
          this.fileListAgent5.splice(i, 1);
          // console.log(this.fileList)
        }
      }
    },
    handleRemoveAgent6 (file) {
      console.log(file, "aaaaa");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      //删除fileList数据
      // console.log(this.fileList);
      for (var i = 0; i < this.fileListAgent6.length; i++) {
        if (this.fileListAgent6[i].id === id) {
          this.fileListAgent6.splice(i, 1);
          // console.log(this.fileList)
        }
      }
    },
    handleRemoveAgent7 (file) {
      console.log(file, "aaaaa");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      //删除fileList数据
      // console.log(this.fileList);
      for (var i = 0; i < this.fileListAgent7.length; i++) {
        if (this.fileListAgent7[i].id === id) {
          this.fileListAgent7.splice(i, 1);
          // console.log(this.fileList)
        }
      }
    },
    handleRemoveAgent8 (file) {
      console.log(file, "方法方法");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      //删除fileList数据
      // console.log(this.fileList);
      for (var i = 0; i < this.fileListAgent8.length; i++) {
        if (this.fileListAgent8[i].id === id) {
          this.fileListAgent8.splice(i, 1);
          // console.log(this.fileList)
        }
      }
    },
    goxieyi () {
      this.agreeIs = true;
    },
    agrees () {
      this.agreeIs = false;
    },
    goBack () {
      this.$router.push({ path: '/agent/agentCopy' })
    },
    getCountryAndCity () {

    },
    insert (formName) {
      this.formLabelAlign1.bscUserInfoAgentBasic.signingFenxiao = 0;
      this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao = 0;
      if ((this.isFenxiao || this.isFenxiao2) && !this.fenxiaozh) {
        console.log(this.formLabelAlign1.bscUserInfoAgentBasic)
        if (this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 == '' || this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 == null
          || this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress == '' || this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress == null
          || this.formLabelAlign1.bscUserInfoAgentBasic.email == '' || this.formLabelAlign1.bscUserInfoAgentBasic.email == null
          || this.formLabelAlign1.bscUserInfoAgentBasic.companytype == '' || this.formLabelAlign1.bscUserInfoAgentBasic.companytype == null
          || this.formLabelAlign1.bscUserInfoAgentBasic.founded == '' || this.formLabelAlign1.bscUserInfoAgentBasic.founded == null
          || this.formLabelAlign1.bscUserInfoAgentBasic.legal == '' || this.formLabelAlign1.bscUserInfoAgentBasic.legal == null
          || this.formLabelAlign1.bscUserInfoAgentBasic.achievement == '' || this.formLabelAlign1.bscUserInfoAgentBasic.achievement == null
          || this.formLabelAlign1.bscUserInfoAgentBasic.personnelNum == '' || this.formLabelAlign1.bscUserInfoAgentBasic.personnelNum == null
          || this.formLabelAlign1.bscUserInfoAgentBasic.brand == '' || this.formLabelAlign1.bscUserInfoAgentBasic.brand == null
          || this.formLabelAlign1.bscUserInfoAgentBasic.legalPhone == '' || this.formLabelAlign1.bscUserInfoAgentBasic.legalPhone == null
          || this.formLabelAlign1.bscUserInfoAgentBasic.name1 == '' || this.formLabelAlign1.bscUserInfoAgentBasic.name1 == null
          || this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone == '' || this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone == null
          || this.formLabelAlign1.bscUserInfoAgentBasic.contactCity == '' || this.formLabelAlign1.bscUserInfoAgentBasic.contactCity == null
          || this.formLabelAlign1.bscUserInfoAgentBasic.region == '' || this.formLabelAlign1.bscUserInfoAgentBasic.region == null
        ) {
          this.$message({
            type: 'warning',
            message: '请填写必填项!'
          })
          return;
        }
        this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao = 1;
        this.formLabelAlign1.bscUserInfoAgentBasic.signingFenxiao = 0;
        if (this.isFenxiao2) {
          this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao = 2;
        }
        ss.SignService.insert(this.formLabelAlign1).then(response => {
          this.$msg.alerts(response.msg, () => {
            this.$router.push({ path: '/login' })
          })
        })
        return;
      }
      if (this.fenxiaozh) {
        //转化分销商
        this.formLabelAlign1.bscUserInfoAgentBasic.signingFenxiao = 1;
        this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao = 1;
      }
      if (this.checked == true) {
        var flag = 0;
        for (var i = 0; i < this.index.length; i++) {
          this.ind = this.index[i];
          var form = formName + this.ind;
          console.log(form)
          this.$refs[form].validate((valid) => {
            if (valid) {

            } else {
              flag = flag + 1;
              return false;
            }
          });
        }
        if (flag !== 0) {
          return false;
        }
        if (this.isZhiDan) {
          this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 1;
          console.log("这是一")
        } else {
          this.isGoverment = false;
          this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 0;
          console.log("这是二")
        }
        if (!this.havepolicy2017) {
          this.$message({
            type: 'warning',
            message: '请您勾选是否包含2017版分类目录！'
          })
          return;
        }
        this.formLabelAlign1.bscUserInfo.fileId = this.refid;
        console.log(this.formLabelAlign1, '提交注册时的数据');
        if (this.have2 === true && this.have3 === false) {
          this.formLabelAlign1.bscUserInfoAgentSell.permit = 2;
        } else if (this.have2 === false && this.have3 === true) {
          this.formLabelAlign1.bscUserInfoAgentSell.permit = 3;
        } else if (this.have2 === true && this.have3 === true) {
          this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
        } else if (this.have2 === false && this.have3 === false) {
          this.formLabelAlign1.bscUserInfoAgentSell.permit = 0;
        }
        if (this.have6858 === true) {
          this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 1;
        } else {
          this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 0;
        }
        if (this.have6840 === true) {
          this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 1;
        } else {
          this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 0;
        }
        if (this.have6854 === true) {
          this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 1;
        } else {
          this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 0;
        }
        if (this.have1101 === true) {
          this.formLabelAlign1.bscUserInfoAgentSell.have1101 = 1;
        } else {
          this.formLabelAlign1.bscUserInfoAgentSell.have1101 = 0;
        }
        if (this.have2214 === true) {
          this.formLabelAlign1.bscUserInfoAgentSell.have2214 = 1;
        } else {
          this.formLabelAlign1.bscUserInfoAgentSell.have2214 = 0;
        }
        if (this.have2215 === true) {
          this.formLabelAlign1.bscUserInfoAgentSell.have2215 = 1;
        } else {
          this.formLabelAlign1.bscUserInfoAgentSell.have2215 = 0;
        }
        if (this.have2216 === true) {
          this.formLabelAlign1.bscUserInfoAgentSell.have2216 = 1;
        } else {
          this.formLabelAlign1.bscUserInfoAgentSell.have2216 = 0;
        }
        this.formLabelAlign1.bscUserInfo.username = this.formLabelAlign1.bscUserInfoAgentBasic.customerName1;
        // if (this.usercode != undefined){
        //     this.formLabelAlign1.oldAgentCode = this.usercode;
        // }
        this.formLabelAlign1.bscUserInfo.email = this.formLabelAlign1.bscUserInfoAgentBasic.email;
        ss.SignService.insert(this.formLabelAlign1).then(response => {
          this.$msg.alerts(response.msg, () => {
            this.$router.push({ path: '/login' })
          })
        })
        // this.updateFile.idList = this.idList;
        // this.updateFile.refid = this.formLabelAlign1.bscUserInfoAgentBasic.customerName1;
        // ss.SignService.updateUploadFile(this.updateFile);

      } else {
        this.$message({
          type: 'warning',
          message: '请您勾选‘我已同意平台协议，再进行注册！’'
        })
      }

    },
    //提交注册供应商
    insertSupplier (formName) {
      if (this.checked == true) {
        var flag = 0;
        for (var i = 0; i < this.indexSupplier.length; i++) {
          this.ind = this.indexSupplier[i];
          var form = formName + this.ind;
          // console.log(form)
          this.$refs[form].validate((valid) => {
            if (valid) {

            } else {
              flag = flag + 1;
              return false;
            }
          });
        }
        // console.log(flag)
        if (flag !== 0) {
          return false;
        }
        console.log(this.supplier, 'supplier')
        //只能是总部供应商才能在首页注册
        this.supplier.bscUserInfoSupplierCopy.type = "1";
        ss.SignService.insertSupplier(this.supplier).then(response => {
          if (response.f) {
            this.$message({
              type: "success",
              message: response.msg
            });
            this.$router.push({ path: '/login' })
          } else {
            this.$message({
              type: "error",
              message: response.msg
            });
          }
        });
        console.log(this.idList, this.supplier.bscUserInfoSupplierCopy.userName, this.reftype, 'aaaaaaaaaaaaaaa');
        this.updateFile.idList = this.idList;
        this.updateFile.refid = this.supplier.bscUserInfoSupplierCopy.userName;
        ss.SignService.updateUploadFile(this.updateFile);

      } else {
        this.$message({
          type: 'warning',
          message: '请您勾选‘我已同意平台协议，再进行注册！’'
        })
      }
    },
    go (index) {
      this.indx = index;
      if (index === 1) {
        this.supplier.bscUserInfoSupplierCopy.inCountry = 'CN';
        this.supplier.bscUserInfoSupplierCopy.bankCountry = 'CN';
        this.supplier.bscUserInfoSupplierCopy.orderCurrency = 'CNY';
      }
    },
    handlePreview (file) {
      console.log(file);
    },
    toLogin () {
      this.$router.push({ path: '/login' })
    },
    /**
     * 经销商查看审批流程
     * */
    lookFlow () {
      if (this.companycodeForLookFlow) {
        ss.SignService.getInstidByName(this.companycodeForLookFlow).then(response => {
          this.instid = response;
          this.showhistory = true;
        })
      } else {
        this.$msg.alerts("请输入要查询的公司名称！");

      }
    },
    lookFenxiao () {
      if (this.username == null || this.username == '') {
        this.$message.error('公司名称不能为空!');
        return;
      }
      if (this.email == null || this.email == '') {
        this.$message.error('邮箱不能为空!');
        return;
      }

      ss.SignService.getFneixaoAgent(this.username, this.email).then(response => {
        if (response.f && response.obj) {

          this.fenxiaozh = true;
          this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao = 2;
          let obj = response.obj;
          //否是直单用户
          if (obj.bscUserInfoAgentBasic.isZhidan == 1) {
            this.isZhiDan = true;
            if (obj.bscUserInfoAgentBasic.companytype = "政府/军工企业") {
              this.isGoverment = true;
            }

          } else {
            this.isZhiDan = false;

          }

          //是否开通海外下单权限
          if (obj.bscUserInfoAgentBasic.isExpandAuthority == 1) {
            this.isExpandAuthority = true;
          } else {
            this.isExpandAuthority = false;
          }
          this.chooseAddAbroad();

          /*********************************radio end******************************/

          /*客户资质信息*/
          this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = obj.bscUserInfoAgentBasic.customerName1;
          if (obj.bscUserInfoAgentBasic.scale !== undefined) {
            this.formLabelAlign1.bscUserInfoAgentBasic.scale = obj.bscUserInfoAgentBasic.scale.toString();
          }
          this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = obj.bscUserInfoAgentBasic.companyAddress;
          this.formLabelAlign1.bscUserInfoAgentBasic.faxNumber = obj.bscUserInfoAgentBasic.faxNumber;
          this.formLabelAlign1.bscUserInfoAgentBasic.email = obj.bscUserInfoAgentBasic.email;
          this.formLabelAlign1.bscUserInfoAgentBasic.companytype = obj.bscUserInfoAgentBasic.companytype;
          this.formLabelAlign1.bscUserInfoAgentBasic.founded = obj.bscUserInfoAgentBasic.founded;
          this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = obj.bscUserInfoAgentBasic.regmoney;
          this.formLabelAlign1.bscUserInfoAgentBasic.legal = obj.bscUserInfoAgentBasic.legal;
          this.formLabelAlign1.bscUserInfoAgentBasic.introduce = obj.bscUserInfoAgentBasic.introduce;
          this.formLabelAlign1.bscUserInfoAgentBasic.business = obj.bscUserInfoAgentBasic.business;
          this.formLabelAlign1.bscUserInfoAgentBasic.achievement = obj.bscUserInfoAgentBasic.achievement;
          this.formLabelAlign1.bscUserInfoAgentBasic.resource = obj.bscUserInfoAgentBasic.resource;
          this.formLabelAlign1.bscUserInfoAgentBasic.name1 = obj.bscUserInfoAgentBasic.name1;
          this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone = obj.bscUserInfoAgentBasic.contactMobilePhone;

          this.formLabelAlign1.bscUserInfoAgentBasic.personnelNum = obj.bscUserInfoAgentBasic.personnelNum;
          this.formLabelAlign1.bscUserInfoAgentBasic.legalPhone = obj.bscUserInfoAgentBasic.legalPhone;
          this.formLabelAlign1.bscUserInfoAgentBasic.brand = obj.bscUserInfoAgentBasic.brand;
          //如果开通海外下单权限
          /* if(obj.bscUserInfoAgentBasic.isExpandAuthority==1){
             this.formLabelAlign1.bscUserInfoAgentBasic.country = obj.bscUserInfoAgentBasic.country;
           }*/

          this.formLabelAlign1.bscUserInfoAgentBasic.region = obj.bscUserInfoAgentBasic.region;
          this.formLabelAlign1.bscUserInfoAgentBasic.contactCity = obj.bscUserInfoAgentBasic.contactCity;
          this.formLabelAlign1.bscUserInfoAgentBasic.businessScale = obj.bscUserInfoAgentBasic.businessScale;
          this.formLabelAlign1.bscUserInfoAgentBasic.staffing = obj.bscUserInfoAgentBasic.staffing;

          this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao = obj.bscUserInfoAgentBasic.isFenxiao;
          this.formLabelAlign1.bscUserInfoAgentBasic.statusFenxiao = obj.bscUserInfoAgentBasic.statusFenxiao;
          this.formLabelAlign1.bscUserInfoAgentBasic.instidFenxiao = obj.bscUserInfoAgentBasic.instidFenxiao;
          this.formLabelAlign1.bscUserInfoAgentBasic.signingFenxiao = obj.bscUserInfoAgentBasic.signingFenxiao;

          /*开票信息*/
          /*this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = obj.bscUserInfoAgentBasic.customerName1*/
          this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = obj.bscUserInfoAgentBasic.phoneNumber;
          this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = obj.bscUserInfoAgentBasic.cityStreetRoom;
          this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = obj.bscUserInfoAgentBasic.taxCode;

        } else {
          this.formLabelAlignNull.bscUserInfoAgentBasic.customerName1 = this.formLabelAlign1.bscUserInfoAgentBasic.customerName1;
          this.formLabelAlignNull.bscUserInfoAgentBasic.email = this.formLabelAlign1.bscUserInfoAgentBasic.email;
          this.formLabelAlign1 = this.formLabelAlignNull;
        }
      })
    },
    //根据邮箱和名称查询驳回的经销商信息
    getBackUserInfo () {
      let userName = this.formLabelAlign1.bscUserInfoAgentBasic.customerName1;
      let email = this.formLabelAlign1.bscUserInfoAgentBasic.email;
      //如果公司名称和邮箱都不为空
      if (userName && email) {
        ss.SignService.getBackUserInfo(userName, email).then(response => {
          if (response.f && response.obj) {
            let obj = response.obj;

            /*********************************radio start******************************/
            //radio 交互代码已写 不太完整 暂时注释
            /* this.formLabelAlign1.bscUserInfoAgentSell.have6858 = obj.bscUserInfoAgentSell.have6858;
             if (obj.bscUserInfoAgentSell.have6858 == 1) {
               this.have6858 = true;
             }
             this.formLabelAlign1.bscUserInfoAgentSell.have6840 = obj.bscUserInfoAgentSell.have6840;
             if (obj.bscUserInfoAgentSell.have6840 == 1) {
               this.have6840 = true;
             }
             this.formLabelAlign1.bscUserInfoAgentSell.have6854 = obj.bscUserInfoAgentSell.have6854;
             if (obj.bscUserInfoAgentSell.have6854 == 1) {
               this.have6854 = true;
             }
             this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 = obj.bscUserInfoAgentSell.haveThree6840;
             if(obj.bscUserInfoAgentSell.haveThree6840 ==1){
                this.haveThree6840 = true;
             }
             //否是直单用户
             if(obj.bscUserInfoAgentBasic.isZhidan==1){
                this.isZhiDan = true;
                if(obj.bscUserInfoAgentBasic.companytype = "政府/军工企业"){
                  this.isGoverment =true;
                }

             }else{
               this.isZhiDan = false;

             }
             this.chooseZhiDan()

             //是否开通海外下单权限
             if(obj.bscUserInfoAgentBasic.isExpandAuthority==1){
               this.isExpandAuthority = true;
             }else{
               this.isExpandAuthority = false;
             }
             this.chooseAddAbroad();


              if (obj.bscUserInfoAgentSell.permit === 5) {
                  this.have2 = true;
                  this.have3 = true;
              } else if (obj.bscUserInfoAgentSell.permit === 2) {
                  this.have2 = true;
              }else if (obj.bscUserInfoAgentSell.permit === 3) {
                  this.have3 = true;
              }*/


            /*********************************radio end******************************/

            /*客户资质信息*/
            this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = obj.bscUserInfoAgentBasic.customerName1;
            if (obj.bscUserInfoAgentBasic.scale !== undefined) {
              this.formLabelAlign1.bscUserInfoAgentBasic.scale = obj.bscUserInfoAgentBasic.scale.toString();
            }
            this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = obj.bscUserInfoAgentBasic.companyAddress;
            this.formLabelAlign1.bscUserInfoAgentBasic.faxNumber = obj.bscUserInfoAgentBasic.faxNumber;
            this.formLabelAlign1.bscUserInfoAgentBasic.email = obj.bscUserInfoAgentBasic.email;
            this.formLabelAlign1.bscUserInfoAgentBasic.companytype = obj.bscUserInfoAgentBasic.companytype;
            this.formLabelAlign1.bscUserInfoAgentBasic.founded = obj.bscUserInfoAgentBasic.founded;
            this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = obj.bscUserInfoAgentBasic.regmoney;
            this.formLabelAlign1.bscUserInfoAgentBasic.legal = obj.bscUserInfoAgentBasic.legal;
            this.formLabelAlign1.bscUserInfoAgentBasic.introduce = obj.bscUserInfoAgentBasic.introduce;
            this.formLabelAlign1.bscUserInfoAgentBasic.business = obj.bscUserInfoAgentBasic.business;
            this.formLabelAlign1.bscUserInfoAgentBasic.achievement = obj.bscUserInfoAgentBasic.achievement;
            this.formLabelAlign1.bscUserInfoAgentBasic.resource = obj.bscUserInfoAgentBasic.resource;
            this.formLabelAlign1.bscUserInfoAgentBasic.name1 = obj.bscUserInfoAgentBasic.name1;
            this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone = obj.bscUserInfoAgentBasic.contactMobilePhone;
            //如果开通海外下单权限
            /* if(obj.bscUserInfoAgentBasic.isExpandAuthority==1){
               this.formLabelAlign1.bscUserInfoAgentBasic.country = obj.bscUserInfoAgentBasic.country;
             }*/

            this.formLabelAlign1.bscUserInfoAgentBasic.region = obj.bscUserInfoAgentBasic.region;
            this.formLabelAlign1.bscUserInfoAgentBasic.contactCity = obj.bscUserInfoAgentBasic.contactCity;
            this.formLabelAlign1.bscUserInfoAgentBasic.businessScale = obj.bscUserInfoAgentBasic.businessScale;
            this.formLabelAlign1.bscUserInfoAgentBasic.staffing = obj.bscUserInfoAgentBasic.staffing;

            /*开票信息*/
            /*this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = obj.bscUserInfoAgentBasic.customerName1*/
            this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = obj.bscUserInfoAgentBasic.phoneNumber;
            this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = obj.bscUserInfoAgentBasic.cityStreetRoom;
            this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = obj.bscUserInfoAgentBasic.taxCode;
            this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = obj.bscUserInfoAgentBank.bankBranchCode;
            this.formLabelAlign1.bscUserInfoAgentBank.bankName = obj.bscUserInfoAgentBank.bankName;
            this.formLabelAlign1.bscUserInfoAgentBank.accountHolderName = obj.bscUserInfoAgentBank.accountHolderName;
            this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = obj.bscUserInfoAgentBank.bankCountry;
            this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = obj.bscUserInfoAgentSell.customerGroup1;
            //如果开通海外下单权限
            /*if(obj.bscUserInfoAgentBasic.isExpandAuthority==1){
               this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms  = obj.bscUserInfoAgentSell.intCommercialTerms;
               this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2 = obj.bscUserInfoAgentSell.intCommercialTerms2;
            }*/

            this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = obj.bscUserInfoAgentSell.currencyCode;

            /*邮寄发票信息*/
            this.formLabelAlign1.bscUserInfoAgentCompany.mailreceiver = obj.bscUserInfoAgentCompany.mailreceiver;
            this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone = obj.bscUserInfoAgentCompany.receiverphone;
            this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.bscUserInfoAgentCompany.mailaddress;


          } else {
            this.formLabelAlignNull.bscUserInfoAgentBasic.customerName1 = this.formLabelAlign1.bscUserInfoAgentBasic.customerName1;
            this.formLabelAlignNull.bscUserInfoAgentBasic.email = this.formLabelAlign1.bscUserInfoAgentBasic.email;
            this.formLabelAlign1 = this.formLabelAlignNull;
          }

        })
      }

      //若公司名称不为空,查询是不是分销商2.0
      if (userName) {
        ss.SignService.getContractByName(userName).then(response => {
          if (response.msg == 1) {
            this.isFenxiao2 = true;
          } else {
            this.isFenxiao2 = false;
            if (null != userName && '' != userName) {
              ss.SignService.getMdmAgent("CUSTOMER_NAME1", userName).then(response => {
                if (response.f && response.obj) {
                  let obj = response.obj;
                  console.log(obj)
                  if (response.f && response.obj) {
                    if (!this.creatNewFlag) {
                      this.$msg.msge("当前公司名称已注册,请走维护功能,客户编码为:" + response.obj.CUSTOMER_NUMBER);
                    }
                    this.formLabelAlign1.bscUserInfoAgentBasic.usercode = response.obj.CUSTOMER_NUMBER;
                    this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = response.obj.TAX_CODE;
                    return;
                  }
                }
              })
            }
          }
        })
      }

    }



  },
  mounted () {
    this.flag = this.$route.query;
    console.log(this.flag[0] === '1', 'flag');
  }
}
</script>
<style scoped>
.redText {
  font-size: 14px;
  color: #e60012;
  margin-top: -60px;
}

.imgBox {
  position: absolute;
  top: 0;
  left: 0;
  height: 650px;
  width: 100%;
  background: url(../assets/images/signBJ.jpg) center/cover;
  z-index: 0;
}

.bannerBox {
  /* width: 13rem; */
  width: 17.5rem;
  margin: 0 auto;
}

.whiteBox {
  width: 100%;
  margin-top: 30px;
  padding: 2px 25px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.3);
  margin-bottom: 73px;
  position: relative;
  z-index: 1;
}

.titles {
  font-size: 16px;
  color: #0e75e9;
  position: relative;
  padding-left: 9px;
  border-left: 5px solid #0e75e9;
  margin-top: 20px;
  margin-bottom: 20px;
  font-weight: bold;
}

.titleBox {
  padding-top: 48px;
  display: flex;
  position: relative;
  z-index: 1;
}

.titleBox p {
  font-size: 30px;
  color: #ffffff;
  padding: 0;
  margin: 0;
  line-height: 50px;
  margin-left: 38px;
}

.buttonBox {
  display: flex;
  align-items: center;
  margin-left: -26px;
}

.buttonBox .selebutton {
  width: 133px;
  height: 46px;
  border-radius: 4px;
  border: solid 2px #d2d2d2;
  text-align: center;
  line-height: 44px;
  margin-left: 26px;
  cursor: pointer;
  color: #9a9a9a;
}

.buttonBox .selebutton.active {
  background-color: #0370ff;
  border-color: #0370ff;
  color: #fff;
}

.bottoms {
  background: #000;
  width: 100%;
  height: 53px;
  text-align: center;
  line-height: 53px;
  font-size: 14px;
  color: #a4a4a4;
}

/* .uploadBox {
    display: flex;
    flex-wrap: wrap;
    margin-top: 44px;
}

.uploadBox .upload {
    width: 40%;
    margin-left: 5%;
    margin-bottom: 27px;
} */
.sign {
  width: 281px;
  height: 46px;
  margin: 0 auto;
  background-color: #2785e7;
  border-radius: 4px;
  line-height: 46px;
  text-align: center;
  color: #fff;
  font-size: 16px;
}

.login {
  margin: 0 auto;
  margin-top: 36px;
  text-align: center;
  color: #999999;
  font-size: 16px;
  margin-bottom: 30px;
}

.checkBoxs {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 58px;
  margin-bottom: 10px;
}

.agreeBox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1;
}

.agreeBox .agree {
  width: 6.2rem;
  max-height: 8rem;
  line-height: 28px;
  background: rgba(0, 0, 0, 0);
  position: absolute;
  border-radius: 10px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.agreeBox .agree .agreeTop {
  width: 100%;
  height: 95%;
  border-radius: 10px;
  background: #fff;
  padding: 0.34rem;
  overflow-y: auto;
}

.agreeBox .agree .agreeTop .title {
  color: #4c4c4c;
  font-size: 24px;
  text-align: center;
  margin-bottom: 0.3rem;
}

.agreeBox .agree .agreeTop .desc {
  font-size: 16px;
  color: #4c4c4c;
  overflow-y: auto;
}

.agreeBox .agree .agreeTop .agreeContinue {
  width: 80%;
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  text-align: center;
  color: #fff;
  background: #0372ff;
  margin: 20px auto 0 auto;
}

.agreeBox .agree .agreeBottom {
  width: 60px;
  height: 60px;
  margin: 10px auto 0 auto;
  cursor: pointer;
}

.checkBoxs .textderictor {
  color: rgb(39, 133, 231);
  font-size: 0.16rem;
  cursor: pointer;
}

.checkBoxs .textderictor:hover {
  text-decoration: underline;
}
</style>
<style>
.uploadBox .upload .el-upload {
  width: 100%;
}

.uploadBox .upload .el-upload .el-button {
  width: 100%;
  text-align: left;
  height: 46px;
}

.signsign .h-formbLine .el-form-item__label {
  width: 40%;
  letter-spacing: 0px;
  /* margin-left: -0.5rem; */
}

.signsign .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 21.8%;
}
.signsign .h-formbLine .h-elformWrap-1.active .el-form-item__label {
  width: 14.5%;
}
.signsign .h-formbLine .h-elformWrap-2 {
  /* width: 33.333%; */
  width: 25%;
  padding-right: 0;
}

.signsign .h-formbLine .el-form-item__content {
  width: 55%;
}

.weekplandetail30 .h-formbLine .el-form-item__label {
  width: 57%;
}

.weekplandetail30 .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 26%;
}

.weekplandetail30 .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 74%;
}

.weekplandetail30 .h-formbLine .el-form-item__content {
  width: 43%;
  margin-top: 0.1rem;
}

.weekplandetail30 .h-formbLine .el-form-item.HAVES-l .el-form-item__label {
  width: 10%;
}

.weekplandetail30 .h-formbLine .el-form-item.HAVES-l .el-form-item__content {
  width: 90%;
}

.weekplandetail30 .el-upload-list__item .el-icon-close-tip {
  right: 40px;
}

.weekplandetail30 .el-upload-list {
  width: 2.5rem;
}

.weekplandetail30 .upload-zizhi {
  margin-top: -0.1rem;
}

.weekplandetail30 .upload-demo {
  margin-top: -0.1rem;
}
</style>
